// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:25:40.053Z
// Property: Woodin Creek Village (ID: 5738458366607360)
// Collections: 47 amenities, 25 floorplans (live), 33 photos, 54 POIs, 5 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5738458366607360",
  "property_external_id": "978674",
  "property_zillow_url": "https://www.zillow.com/apartments/woodinville-wa/woodin-creek-village/CgGsnN/",
  "property_apartments_url": "https://www.apartments.com/woodin-creek-village-woodinville-wa/vbhnfsg",
  "property_google_business_url": "https://www.google.com/maps/place/Woodin+Creek+Village+Apartment+Homes/@47.7522247,-122.1594149,15z/data=!4m2!3m1!1s0x0:0x1ba7747337f887c3?sa=X&ved=2ahUKEwiClrnyhPTtAhVrhOAKHUBZBRsQ_BIwEnoECCUQBQ",
  "property_linkedin_url": null,
  "property_hubspot_id": "3256169680",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "woodin-creek-village",
  "property_name": "Woodin Creek Village",
  "property_website_url": "https://www.woodincreekvillage.com",
  "property_domain": "https://www.woodincreekvillage.com",
  "property_address": "17255 135th Ave NE",
  "property_full_address": "17255 135th Ave NE, Woodinville, WA 98072",
  "property_address_1": "17255 135th Ave NE",
  "property_address_2": null,
  "property_address_city": "Woodinville",
  "property_address_state": "WA",
  "property_address_zip_full": "98072",
  "property_address_zip": "98072",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Town Center",
  "property_address_latitude": "47.7520992",
  "property_address_longitude": "-122.1594319",
  "property_email": "woodincreek@weidner.com",
  "property_phone": "(425) 256-4100",
  "property_call_tracking_phone": "425-256-4096",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Woodin Creek Village expertly pairs luxury apartments with Woodinville, WA’s charm. Our neighborhood-like community holds high-end studio, one, and two bedroom floor plans above the area’s best retailers and restaurants. The Tuscan-inspired designs complement world-class wine tastings offered at 11 local tasting rooms adjacent to desirable amenities and 11 miles of paved trails. The community’s elegance carries into the open-concept apartments with designer finishes, gourmet kitchens, and hardwood-style flooring that will elevate your idea of apartment living.</p>",
  "property_long_description": "<p><strong>Wine country energy meets everyday ease at Woodin Creek Village.</strong> Set in Woodinville’s Town Center, this mixed-use community places studio, one-, and two-bedroom apartments above and around restaurants, shops, and tasting rooms, with Woodinville Wine Country, the Sammamish River Valley, Wilmot Gateway Park, and Chateau Ste. Michelle all close to home.</p><p>Inside, choose from thoughtfully designed <a href=\"/floor-plans\">floor plans</a> with open layouts, granite countertops, in-home laundry, hardwood-style flooring, and select features like gas ranges, kitchen islands, fireplaces, vaulted ceilings, oversized decks, and walk-in closets. Beyond your front door, <a href=\"/amenities\">community amenities</a> bring the best of the village together: a fitness center, rooftop spa, rooftop lounge with firepits, courtyards, grilling areas, EV charging, bike storage, concierge service, social events, and pet-friendly spaces including a rooftop dog run.</p><p>When you want to get out, explore nearby wineries, dinner spots, trails, parks, and convenient routes to the Eastside via I-405, SR 522, and SR 202 from this connected <a href=\"/neighborhood\">Woodinville neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
  "property_featured_image_media": {
    "alt_text": "Bar area with seating and wine bottles on shelves",
    "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
    "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
    "width": 3072,
    "height": 1730
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "778",
  "property_year_built": "2015",
  "property_year_renovated": null,
  "property_walk_score": "67",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.62982005141389",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": "Pets - Max 2 allowed, One time Fee $250.00, Rent $45.00, Deposit $300.00\nCats - allowed\nDogs - allowed, Max weight 80 lb each\nBreed Restrictions Apply ",
  "property_online_leasing_url": "https://woodincreekvillage.securecafe.com/onlineleasing/woodin-creek-village/floorplans.aspx",
  "property_resident_portal_url": "https://woodincreekvillage.securecafenet.com/residentservices/woodin-creek-village/userlogin",
  "property_apply_now_url": "https://woodincreekvillage.securecafe.com/onlineleasing/woodin-creek-village/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-2323-7253-a756-13c05b0f2427.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodin Creek Village logo with square emblem and bold text",
    "public_id": "019d01a2-2323-7253-a756-13c05b0f2427",
    "storage_key": "property/5738458366607360/019d01a2-2323-7253-a756-13c05b0f2427.webp",
    "width": 407,
    "height": 201
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a4-09d1-7779-abc5-44c46d87f13f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a4-09d1-7779-abc5-44c46d87f13f",
    "storage_key": "property/5738458366607360/019d01a4-09d1-7779-abc5-44c46d87f13f.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#CB9733",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1476",
  "property_sqft_min": "376",
  "property_sqft_max": "1644",
  "property_price_range": "7 - 3655",
  "property_price_min": "1765",
  "property_price_max": "3645",
  "property_available_units": 34,
  "property_facebook_url": "https://www.facebook.com/WoodinCreek/",
  "property_instagram_url": "https://www.instagram.com/woodincreekvillage/",
  "property_twitter_url": "https://twitter.com/woodincreek",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJf16QkCsMkFQRw4f4N3N0pxs",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodin Creek Village",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p>Expand your living space at one of our many community amenities to help you connect with your neighbors, enjoy your hobbies, and entertain your guests.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> From streamlined studios to open one- and two-bedroom apartments, Woodin Creek Village offers floor plans with standout options like dens, penthouse-style layouts, expansive decks, and central air in select homes. Expect everyday ease with in-home laundry, granite countertops, dishwashers, microwaves, and appliance finish choices—plus select features like kitchen islands, gas ranges, pantries, fireplaces, vaulted ceilings, walk-in closets, and patio or balcony space.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the look and feel of Woodin Creek Village.</strong> Explore bright interiors, granite-topped kitchens, inviting living spaces, and select homes with fireplaces, vaulted ceilings, or outdoor decks. Beyond the apartment, gallery highlights include courtyard views, rooftop firepits and spa, lounge seating, fitness space, pet-friendly outdoor areas, and walkable Woodinville streets just outside.</p>",
  "property_home_neighborhood_blurb": "<p>Welcome to the Woodin Creek Village neighborhood! You can have it all with luxury apartment living steps away from award-winning restaurants and wineries.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Woodin Creek Village feels like more than an address.</strong> Reviews call out responsive management, quick maintenance, and connection-driven events—from rooftop happy hours and yoga to plaza music, workshops, walking groups, and the community puzzle. Add a walkable Town Center setting, rooftop hot tubs, BBQ areas, guest suites, indoor parking, and the WCV app, and it’s easy to see why the reviews are worth a closer look.</p>",
  "property_neighborhood_blurb": "<p>Welcome to the Woodin Creek Village neighborhood! You can have it all with luxury apartment living steps away from award-winning restaurants and wineries.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Expand your living space at one of our many community amenities to help you connect with your neighbors, enjoy your hobbies, and entertain your guests.</p><p>We crafted each apartment home with you in mind! Every floor plan provides top-of-the-line appliances, high-end finishes, and spacious layouts.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Woodin Creek Village.</strong><br>Apply online for a studio, one-, or two-bedroom apartment with open layouts, granite countertops, in-home laundry, and hardwood-style flooring—all set in a Town Center community with dining, shopping, and wine country energy close at hand.</p>",
  "property_contactus_blurb": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in luxury at Woodin Creek Village.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Woodin Creek Village?</strong> Find quick answers about leasing, floor plans, amenities, and everyday living in this Woodinville Town Center community. If you need more details or want help choosing your next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Your perfect apartment is a click away! Choose from nearly a dozen thoughtfully designed floor plans of studio, one, or two-bedroom homes.</p>",
  "property_gallery_blurb": "<p>You belong here! Picture yourself in Woodin Creek Village’s luxury apartments in Woodinville, WA. Notice each home’s elevated features, view the desirable amenities, and take in the community’s welcoming atmosphere.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Woodin Creek Village on the map.</strong><br>See available apartments in Woodinville’s Town Center, then scan the surrounding restaurants, shops, tasting rooms, parks, trails, and routes that keep Wine Country energy close to everyday ease.</p>",
  "property_pets_blurb": "<p>At Woodin Creek Village, we aren’t just pet-friendly; we LOVE pets! So much so that we’ve incorporated pet-specific amenities into our community, like a fenced-in pet play area, a rooftop dog run, and community-wide Yappy Hours where your furry friend can meet their four-legged neighbors.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Woodin Creek Village?</strong> Share the wine country energy, everyday ease, and Town Center setting with a friend. Invite them to explore thoughtfully designed apartments, village dining and shops, and community spaces made for relaxing, connecting, and enjoying Woodinville close to home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Woodin Creek Village.</strong><br>Everyday ease continues online. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to the Town Center energy, dining, shops, and tasting rooms right outside your door.</p>",
  "property_reviews_blurb": "<p><strong>Resident reviews tell the Woodin Creek Village story best:</strong> everyday apartment living can turn into real connection. Residents consistently praise responsive management, fast maintenance, and a social calendar shaped by Lifestyle Director Fab—from rooftop happy hours and yoga to walking groups, workshops, music in the plaza, and even the community puzzle.</p><p>You’ll also see love for the walkable Town Center setting, well-kept gathering spaces, rooftop hot tubs, BBQ areas, indoor parking, guest suites, and easy ways to connect through the WCV app. As one resident put it, Woodin Creek Village is “more than just an apartment community.” Browse the reviews below to hear what life here feels like from the people who know it firsthand.</p>",
  "property_created_at": "1752256663577",
  "property_scheduletour_blurb": "<p><strong>See Woodin Creek Village in person.</strong><br>Tour open layouts with granite countertops, in-home laundry, and hardwood-style flooring, then take in the village setting with restaurants, shops, tasting rooms, rooftop spaces, and courtyards just beyond your door. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with more details. In the meantime, picture life at Woodin Creek Village: open apartment layouts, stylish finishes, and everyday access to dining, shops, tasting rooms, and welcoming community spaces in the heart of Woodinville’s Town Center.</p>",
  "property_virtualtours_blurb": "<p>Explore your future apartment by viewing our virtual tours. Take a look around – we know you’ll love it here!</p>",
  "property_copyright": "2026 All Rights Reserved. Woodin Creek Village",
  "property_seo_title_home": "Woodin Creek Village |  Apartments in Woodinville, WA",
  "property_seo_description_home": "Embrace modern living at Woodin Creek Village! Choose stylish studios or spacious two-bedrooms with top amenities in vibrant Woodinville, WA.",
  "property_seo_title_floorplans": "Floor Plans | Woodinville, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Woodin Creek Village in Woodinville, WA. From cozy studios to spacious two-bedrooms, your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Woodinville, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and luxury at Woodin Creek Village! Enjoy a rooftop spa, fitness center, and vibrant social events—all in a walkable Woodinville setting.",
  "property_seo_title_gallery": "Gallery | Apartments in Woodinville, WA",
  "property_seo_description_gallery": "Immerse yourself in luxury at Woodin Creek Village, where stunning floor plans meet exceptional amenities. Picture vibrant living in Woodinville, WA!",
  "property_seo_title_virtualtours": "Virtual Tours | Woodin Creek Village Apartments",
  "property_seo_description_virtualtours": "Experience Woodin Creek Village in Woodinville, WA! Tour stunning studio, one- and two-bedroom apartments from the comfort of home. Your dream space awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Woodin Creek Village Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Woodin Creek Village in Woodinville, WA! Explore diverse floor plans and vibrant amenities with our interactive community map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Woodinville, WA",
  "property_seo_description_neighborhood": "Discover the charm of Woodinville at Woodin Creek Village—local gems, vibrant favorites, and everything our neighborhood has to offer!",
  "property_seo_title_contact": "Contact Us | Woodin Creek Village",
  "property_seo_description_contact": "Contact Woodin Creek Village in Woodinville, WA! Our leasing team is here to answer your questions about our studio and one- or two-bedroom apartments.",
  "property_seo_title_faqs": "FAQs | Apartments in Woodinville, WA",
  "property_seo_description_faqs": "Find all your questions answered at Woodin Creek Village! From floor plans to amenities, discover what makes our Woodinville community the perfect home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Woodinville, WA",
  "property_seo_description_reviews": "Uncover the authentic experiences at Woodin Creek Village in Woodinville, WA! See why residents love their homes and our vibrant community lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Woodinville, WA",
  "property_seo_description_applynow": "Elevate your lifestyle at Woodin Creek Village in Woodinville, WA. Stylish apartments, top amenities, and vibrant events await. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Woodin Creek Village",
  "property_seo_description_residentaccess": "Access your Woodin Creek Village resident portal for easy rent payments, maintenance requests, and community updates. Your home in Woodinville awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Woodin Creek Village",
  "property_seo_description_referafriend": "Great friends make great neighbors—refer a friend to Woodin Creek Village in Woodinville, WA, and share the joy of vibrant community living!",
  "property_seo_title_scheduletour": "Schedule a Tour | Woodin Creek Village",
  "property_seo_description_scheduletour": "Experience the charm of Woodin Creek Village in Woodinville, WA. Schedule a tour today and envision your new home in this vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Woodin Creek Village",
  "property_seo_description_privacy": "Your privacy matters at Woodin Creek Village. Safeguarding your information is our priority. Learn more about our commitment to your data security.",
  "property_seo_title_accessibility": "Website Accessibility | Woodin Creek Village",
  "property_seo_description_accessibility": "At Woodin Creek Village in Woodinville, WA, we prioritize accessibility and digital inclusion, ensuring everyone can enjoy our vibrant community. Join us!",
  "property_seo_title_sitemap": "Sitemap | Woodin Creek Village",
  "property_seo_description_sitemap": "Explore Woodin Creek Village! Discover community insights, amenities, and floor plans in our sitemap for an ultimate living experience in Woodinville, WA.",
  "property_seo_title_thankyou": "Thank You | Woodin Creek Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Woodin Creek Village! Our team will connect soon to assist you in finding your perfect home in beautiful Woodinville, WA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Woodinville, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793721965823",
  "amenities": [
    {
      "id": "ec_dcf924ac2a09a39098539f82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769545",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6834a3e33b18a97c9ef9e0fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769539",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e9dea47081c9dcf21e712d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "88553870",
      "title": "Rooftop Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03c74-bc1d-767f-9ee1-e3b942dc30c9.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor hot tub on a rooftop deck with a blue sky and white clouds.",
        "public_id": "01a03c74-bc1d-767f-9ee1-e3b942dc30c9",
        "storage_key": "property/5738458366607360/01a03c74-bc1d-767f-9ee1-e3b942dc30c9.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92552977e4cd781fce82e6f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769537",
      "title": "Community Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b715e22a10535e4eeb4d2910",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769518",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c60cce001323cb4cd670071a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769519",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_941db44cbf51325e2b51c060",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "88553876",
      "title": "Concierge Services",
      "amount": "false",
      "description": "Select Homes",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b165cabedfb0ae24a58f740",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769524",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bd31a0552eeb7e11f6511bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769555",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d99dc-09b5-7520-a595-879cc3fe4ec2.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019d99dc-09b5-7520-a595-879cc3fe4ec2",
        "storage_key": "property/5738458366607360/019d99dc-09b5-7520-a595-879cc3fe4ec2.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5af4c79232f8e3c0d0b3c02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769568",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d99dc-09c4-7789-a161-f039918df045.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and fireplace.",
        "public_id": "019d99dc-09c4-7789-a161-f039918df045",
        "storage_key": "property/5738458366607360/019d99dc-09c4-7789-a161-f039918df045.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e40ab0bd5e63d6790bc9e81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769556",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2dc6c4ceab3951c91dcc3629",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769557",
      "title": "Gas Range*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d229e711348ee4d56b899f0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769558",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_713e8da7ca5100e0c8055b77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769559",
      "title": "Energy Star Certified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_231f44915f92f3faed6741d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769566",
      "title": "Central AC and Heating per apartment*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffc2e99c0afcd885ea652d24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769569",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efcb4e1d64423f69d309f9bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769572",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20934599271a69be19b77ae6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769577",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7744d641633f658e05701cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769527",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f17373140bc447864ba7bd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769563",
      "title": "Variety of Interior Finishes with Black, White, or Stainless Steel Kitchen appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03c74-bb6e-724f-bd50-55a9258c9c17.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with large island, stainless steel appliances, and pendant lighting.",
        "public_id": "01a03c74-bb6e-724f-bd50-55a9258c9c17",
        "storage_key": "property/5738458366607360/01a03c74-bb6e-724f-bd50-55a9258c9c17.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b74af3a5d1c741a43882ef8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769560",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-08f5-7312-b1c7-d06e420a7dad.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with large island, stainless steel appliances, and pendant lighting.",
        "public_id": "019d01a2-08f5-7312-b1c7-d06e420a7dad",
        "storage_key": "property/5738458366607360/019d01a2-08f5-7312-b1c7-d06e420a7dad.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cb5cccfea01befc60521dff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769543",
      "title": "Rooftop Lounge & Firepits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-094c-75f8-803d-b3eb05a8a925.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and lounge area with large windows overlooking an outdoor patio with a fireplace and seating.",
        "public_id": "019d01a2-094c-75f8-803d-b3eb05a8a925",
        "storage_key": "property/5738458366607360/019d01a2-094c-75f8-803d-b3eb05a8a925.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17973db6d42e71e6830d2641",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769570",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-09cc-72e9-8c40-c87887189f66.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and living area with island and balcony access.",
        "public_id": "019d01a2-09cc-72e9-8c40-c87887189f66",
        "storage_key": "property/5738458366607360/019d01a2-09cc-72e9-8c40-c87887189f66.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2db532b6f67db5e361259c1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769552",
      "title": "Rooftop Dog Run",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6e1a0a89f77b245d36f1052",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769526",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53eb936732b62b13b89a1f86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769534",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c59097aa32791f125fe7ab71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769561",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_351cc75d444c3607ec56f95b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769541",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9995b6bffe0426cfd79e9e6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769562",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef1659ae21eedbda9d513567",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769522",
      "title": "Community-Wide WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbfa2b0a67362f9385206033",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "86769523",
      "title": "Social Events, Food Trucks, Wine Nights and more!",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90901a1f3d39c1fa15202288",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "88553878",
      "title": "Walkable Neighborhood near Restaurants and Wineries",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1d7487e34f0e556f996933c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "87937967",
      "title": "*Select Apartment Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66cb49128cf795842149aabc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "121237829",
      "title": "Bike Repair Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adbd81f85a2f5eb1b6af00a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "124800128",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_958b6ee15ecb03cb21febe1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768189",
      "title": "No Open Window",
      "amount": "false",
      "description": "No Open Window",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_913732557661f57292e8f415",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768190",
      "title": "No Patio",
      "amount": "false",
      "description": "No Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d31d600ad8f71eecb1973c53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768191",
      "title": "Obstructed View",
      "amount": "false",
      "description": "Obstructed View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_942169a4365ef206fc510a0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768192",
      "title": "Oversized Deck",
      "amount": "false",
      "description": "Oversized Deck",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a98fdc6d4c9e330cd4bc9268",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768193",
      "title": "Pantry",
      "amount": "false",
      "description": "Pantry",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca476caa355020971c688009",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768194",
      "title": "Penthouse",
      "amount": "false",
      "description": "Penthouse",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d35654143ed03afa7a406afd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768196",
      "title": "Penthouse Deck",
      "amount": "false",
      "description": "Penthouse Deck",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_925ace02c62eb2585cbef3ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768197",
      "title": "Sidewalk Access",
      "amount": "false",
      "description": "Sidewalk Access",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34aab96eb9b070a6de67f03b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768198",
      "title": "Southern Exposure",
      "amount": "false",
      "description": "Southern Exposure",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d11c30ab914f7a1dddeeb7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768199",
      "title": "Stoop Access street",
      "amount": "false",
      "description": "Stoop Access street",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e21548aa84a6167427f643eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768201",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "Vaulted Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be4284c16f6b97d0e4b961c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "126768202",
      "title": "Walk-in Closet",
      "amount": "false",
      "description": "Walk-in Closet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_a67ec9eef6064fe4c2d411f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy a drink at our stylish bar, complete with a wide selection of wine and comfortable seating.",
      "link": "false",
      "alt_text": "A bar with people sitting at tables and a woman in a yellow shirt.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(28).jpg"
    },
    {
      "id": "ec_7b9f15ff2f7850487c2b8ed4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-4cf3-730f-a908-297d58dfe9b0.webp",
      "image_media": {
        "alt_text": "Modern lobby with red chairs and fireplace.",
        "public_id": "01a03755-4cf3-730f-a908-297d58dfe9b0",
        "storage_key": "property/5738458366607360/01a03755-4cf3-730f-a908-297d58dfe9b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, a modern fireplace, and elegant decor.",
      "link": "false",
      "alt_text": "A living room with a red rug and red chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(12).jpg"
    },
    {
      "id": "ec_31cc4637bdc81e42ead8e65a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-32ed-73a5-aaea-4fc2025a431a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, soaking tub, and sleek fixtures.",
        "public_id": "01a03755-32ed-73a5-aaea-4fc2025a431a",
        "storage_key": "property/5738458366607360/01a03755-32ed-73a5-aaea-4fc2025a431a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom featuring a double vanity with vessel sinks, a deep soaking tub, and elegant finishes.",
      "link": "false",
      "alt_text": "A bathroom with a white sink and a white toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(8).jpg"
    },
    {
      "id": "ec_274fee8e3a5e8e600cebd3d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-5455-7495-b446-bc6829bb3e4c.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating, umbrellas, and a grill station.",
        "public_id": "01a03755-5455-7495-b446-bc6829bb3e4c",
        "storage_key": "property/5738458366607360/01a03755-5455-7495-b446-bc6829bb3e4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor lounge, perfect for relaxing or entertaining, featuring comfortable seating, vibrant umbrellas, and a built-in grill station.",
      "link": "false",
      "alt_text": "A modern outdoor seating area with a wooden bench and red planters.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(16).jpg"
    },
    {
      "id": "ec_06ebfd366abe22435dc2801a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-4aab-7608-90ad-1fa35465f50c.webp",
      "image_media": {
        "alt_text": "Rooftop patio with artificial turf and modern planters.",
        "public_id": "01a03755-4aab-7608-90ad-1fa35465f50c",
        "storage_key": "property/5738458366607360/01a03755-4aab-7608-90ad-1fa35465f50c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living on your private rooftop patio, featuring a patch of artificial turf for relaxation and stylish, modern planters for a touch of greenery.",
      "link": "false",
      "alt_text": "A modern backyard with a green lawn and a concrete patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(18).jpg"
    },
    {
      "id": "ec_78c12d53a1bc421243240ce5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-5aef-72aa-ac2e-73d8b625a40d.webp",
      "image_media": {
        "alt_text": "Modern apartment building gym with treadmills, weight machines, and free weights.",
        "public_id": "01a03755-5aef-72aa-ac2e-73d8b625a40d",
        "storage_key": "property/5738458366607360/01a03755-5aef-72aa-ac2e-73d8b625a40d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, weight training equipment, and a spacious workout area.",
      "link": "false",
      "alt_text": "A gym with a red and grey carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(15).jpg"
    },
    {
      "id": "ec_dd7dbf913a48432864e98da1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-8769-702e-940e-d8ceddc4a1be.webp",
      "image_media": {
        "alt_text": "A climate-controlled wine cellar with racks of wine bottles and a wooden barrel.",
        "public_id": "01a03755-8769-702e-940e-d8ceddc4a1be",
        "storage_key": "property/5738458366607360/01a03755-8769-702e-940e-d8ceddc4a1be.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy wine connoisseur living with our expansive, climate-controlled wine cellar, perfect for storing your collection.",
      "link": "false",
      "alt_text": "A wine cellar with racks of wine bottles.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(25).jpg"
    },
    {
      "id": "ec_af89ea2985090851552995b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-a5eb-7193-95cf-ea1f00dd5f56.webp",
      "image_media": {
        "alt_text": "Rooftop hot tub with a clear blue sky and fluffy clouds.",
        "public_id": "01a03755-a5eb-7193-95cf-ea1f00dd5f56",
        "storage_key": "property/5738458366607360/01a03755-a5eb-7193-95cf-ea1f00dd5f56.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our luxurious rooftop hot tub, offering stunning sky views and a tranquil atmosphere.",
      "link": "false",
      "alt_text": "A small pool with a glass fence around it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(17).jpg"
    },
    {
      "id": "ec_e4d1e6bf09649e49d55fd1e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-ab21-7199-a7d0-5581dd3ade3d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and walk-in closet.",
        "public_id": "01a03755-ab21-7199-a7d0-5581dd3ade3d",
        "storage_key": "property/5738458366607360/01a03755-ab21-7199-a7d0-5581dd3ade3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed, a stylish nightstand, and a spacious walk-in closet for ample storage.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(9).jpg"
    },
    {
      "id": "ec_040d9222eeec6c115a805d7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-c3f4-736d-a451-c554eb580c7c.webp",
      "image_media": {
        "alt_text": "People gathered around classic cars at an outdoor event in front of apartment buildings.",
        "public_id": "01a03755-c3f4-736d-a451-c554eb580c7c",
        "storage_key": "property/5738458366607360/01a03755-c3f4-736d-a451-c554eb580c7c.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Lifestyle",
      "description": "Enjoy community events and a vibrant lifestyle at our apartment complex, featuring classic car shows and outdoor gatherings.",
      "link": "false",
      "alt_text": "A blue car is parked next to a red car with its hood open.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(30).jpg"
    },
    {
      "id": "ec_4c39019615b3e116f04f64fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-c4c6-7489-8659-6d3e471c6bfb.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with outdoor seating and lush landscaping.",
        "public_id": "01a03755-c4c6-7489-8659-6d3e471c6bfb",
        "storage_key": "property/5738458366607360/01a03755-c4c6-7489-8659-6d3e471c6bfb.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Discover the vibrant community and sophisticated living spaces of our apartment complex, featuring stylish architecture and inviting outdoor amenities.",
      "link": "false",
      "alt_text": "A building with a balcony and a yellow fire hydrant on the sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(27).jpg"
    },
    {
      "id": "ec_d6c84788282e787bd0b99354",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03755-cd10-73ca-9e75-81c7c47a5de4.webp",
      "image_media": {
        "alt_text": "Modern community kitchen island with wine fridges, sink, and stovetop.",
        "public_id": "01a03755-cd10-73ca-9e75-81c7c47a5de4",
        "storage_key": "property/5738458366607360/01a03755-cd10-73ca-9e75-81c7c47a5de4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gourmet community kitchen island featuring sleek white countertops, built-in wine refrigerators, a sink, and a stovetop, perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with white marble countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(13).jpg"
    },
    {
      "id": "ec_1c996ca421b03dd4bc2b92b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-01bc-77c7-8414-aebde1d2fa17.webp",
      "image_media": {
        "alt_text": "Elegant wine bar with a long marble counter, plush seating, and a well-stocked wine display.",
        "public_id": "01a03756-01bc-77c7-8414-aebde1d2fa17",
        "storage_key": "property/5738458366607360/01a03756-01bc-77c7-8414-aebde1d2fa17.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Experience the refined ambiance of our wine bar, featuring a sophisticated marble counter, luxurious leather seating, and an extensive selection of wines for your enjoyment.",
      "link": "false",
      "alt_text": "A modern restaurant with wooden tables and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(26).jpg"
    },
    {
      "id": "ec_15fd79d43082df017afb7612",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-00b0-7538-bb8a-ea005f2f19e0.webp",
      "image_media": {
        "alt_text": "Man walking two dogs on a sidewalk in front of a building with outdoor dining.",
        "public_id": "01a03756-00b0-7538-bb8a-ea005f2f19e0",
        "storage_key": "property/5738458366607360/01a03756-00b0-7538-bb8a-ea005f2f19e0.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Lifestyle",
      "description": "Enjoy a stroll with your furry friends along the vibrant streetscape, adjacent to lively dining options and lush landscaping.",
      "link": "false",
      "alt_text": "A man walking a dog on a leash in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(33).jpg"
    },
    {
      "id": "ec_87582df6fdaccc6573cfe681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-0ab5-740e-9d8f-8b91aebbb2c4.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with colorful buildings and lush green landscaping.",
        "public_id": "01a03756-0ab5-740e-9d8f-8b91aebbb2c4",
        "storage_key": "property/5738458366607360/01a03756-0ab5-740e-9d8f-8b91aebbb2c4.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living at this vibrant apartment community, featuring modern architecture and beautiful natural surroundings.",
      "link": "false",
      "alt_text": "A large apartment complex with multiple buildings and a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(19).jpg"
    },
    {
      "id": "ec_15bd2e9c8c2be861f2c86ce1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-1b16-75be-b4c9-c719e059c11f.webp",
      "image_media": {
        "alt_text": "Modern reception area with a curved bar, stylish pendant lights, and comfortable seating.",
        "public_id": "01a03756-1b16-75be-b4c9-c719e059c11f",
        "storage_key": "property/5738458366607360/01a03756-1b16-75be-b4c9-c719e059c11f.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Welcome guests into our sophisticated reception area, featuring a sleek curved bar, contemporary pendant lighting, and inviting seating arrangements.",
      "link": "false",
      "alt_text": "A modern bar with a wooden counter and a TV on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(21).jpg"
    },
    {
      "id": "ec_eeafc47acf0d22db180aba35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-2d6b-734a-a151-2d4d9bc2aaae.webp",
      "image_media": {
        "alt_text": "Exterior of a mixed-use building with retail and apartments, featuring signage for Alexandria Nicole Cellars and Brix.",
        "public_id": "01a03756-2d6b-734a-a151-2d4d9bc2aaae",
        "storage_key": "property/5738458366607360/01a03756-2d6b-734a-a151-2d4d9bc2aaae.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Discover modern living in this vibrant community, boasting stylish retail spaces and comfortable apartment homes. Enjoy the convenience of on-site amenities and a prime location.",
      "link": "false",
      "alt_text": "A man and a woman are walking on a sidewalk past a building with a sign that reads \"1010\".",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(23).jpg"
    },
    {
      "id": "ec_48b8f4cb38452e6bf85db74e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-4b9d-73ef-804c-776f84dc6a52.webp",
      "image_media": {
        "alt_text": "Closet with shopping bags and baskets next to a double vanity bathroom.",
        "public_id": "01a03756-4b9d-73ef-804c-776f84dc6a52",
        "storage_key": "property/5738458366607360/01a03756-4b9d-73ef-804c-776f84dc6a52.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with shelving and decorative baskets, adjacent to a modern bathroom with a double vanity and ample counter space.",
      "link": "false",
      "alt_text": "A bathroom with a white wall and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(10).jpg"
    },
    {
      "id": "ec_5b1ce920ef438fed76d69552",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-5228-7517-ac82-20219770e516.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a modern gas fire pit, bench, and chairs.",
        "public_id": "01a03756-5228-7517-ac82-20219770e516",
        "storage_key": "property/5738458366607360/01a03756-5228-7517-ac82-20219770e516.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy a relaxing evening in our outdoor lounge area, complete with a stylish gas fire pit and comfortable seating.",
      "link": "false",
      "alt_text": "A modern outdoor seating area with a fireplace and comfortable chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(24).jpg"
    },
    {
      "id": "ec_fe21b258c33199c43c147bd9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-64ea-7476-bef4-9ba3b67543fc.webp",
      "image_media": {
        "alt_text": "Walkway between apartment buildings with outdoor seating and landscaping.",
        "public_id": "01a03756-64ea-7476-bef4-9ba3b67543fc",
        "storage_key": "property/5738458366607360/01a03756-64ea-7476-bef4-9ba3b67543fc.webp",
        "width": 3072,
        "height": 1731
      },
      "title": "Community",
      "description": "Enjoy the vibrant community atmosphere with charming walkways, outdoor seating, and lush greenery.",
      "link": "false",
      "alt_text": "A man is walking down a brick pathway in a courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(31).jpg"
    },
    {
      "id": "ec_69e67a3484fa76e0eef045ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-7b95-776f-b56f-1dcd70e9848d.webp",
      "image_media": {
        "alt_text": "Four bright red Adirondack chairs arranged in a row on a paved walkway, with lush greenery and a modern apartment building in the background.",
        "public_id": "01a03756-7b95-776f-b56f-1dcd70e9848d",
        "storage_key": "property/5738458366607360/01a03756-7b95-776f-b56f-1dcd70e9848d.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor spaces. These comfortable Adirondack chairs offer a perfect spot to enjoy the vibrant community atmosphere and beautiful landscaping.",
      "link": "false",
      "alt_text": "Four red chairs are arranged in a row on a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(32).jpg"
    },
    {
      "id": "ec_eda1087400331a9f1139664b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03c74-c805-7683-bab7-d188bbe6bd5e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual sinks and a view into the bedroom.",
        "public_id": "01a03c74-c805-7683-bab7-d188bbe6bd5e",
        "storage_key": "property/5738458366607360/01a03c74-c805-7683-bab7-d188bbe6bd5e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space and elegant fixtures, leading into a comfortable bedroom area.",
      "link": "false",
      "alt_text": "A bathroom with a white sink and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(5).jpg"
    },
    {
      "id": "ec_71aebe62f26f91cf76ce8034",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-7d8a-706f-95bd-f398ff734b21.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment unit with an open-concept kitchen and living room featuring a fireplace and large windows.",
        "public_id": "01a03756-7d8a-706f-95bd-f398ff734b21",
        "storage_key": "property/5738458366607360/01a03756-7d8a-706f-95bd-f398ff734b21.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully designed apartment, showcasing a modern kitchen and a spacious living area with a cozy fireplace and abundant natural light.",
      "link": "false",
      "alt_text": "A kitchen with a stove top oven and a microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(4).jpg"
    },
    {
      "id": "ec_996e6c3e7984db2dfa51d260",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-9e11-736f-9150-44f02d2e57c6.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern apartment complex gym.",
        "public_id": "01a03756-9e11-736f-9150-44f02d2e57c6",
        "storage_key": "property/5738458366607360/01a03756-9e11-736f-9150-44f02d2e57c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and stationary bikes for a complete workout.",
      "link": "false",
      "alt_text": "A gym with treadmills and exercise bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(14).jpg"
    },
    {
      "id": "ec_33319009bb81eea0433189f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-af9b-737f-a0f2-c4a0283d18dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, granite countertops, and a central island.",
        "public_id": "01a03756-af9b-737f-a0f2-c4a0283d18dd",
        "storage_key": "property/5738458366607360/01a03756-af9b-737f-a0f2-c4a0283d18dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment kitchen featuring sleek wood cabinetry, granite countertops, a full suite of modern appliances including a microwave and dishwasher, and a convenient central island for meal prep and dining.",
      "link": "false",
      "alt_text": "A kitchen with a black refrigerator, stove, and oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(3).jpg"
    },
    {
      "id": "ec_d11bfc6236c3af6c58e25a2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-be5c-74e9-8aa6-339db45906d0.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer unit in apartment laundry closet.",
        "public_id": "01a03756-be5c-74e9-8aa6-339db45906d0",
        "storage_key": "property/5738458366607360/01a03756-be5c-74e9-8aa6-339db45906d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit stacked washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "A laundry room with a washer and dryer stacked on top of each other.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(11).jpg"
    },
    {
      "id": "ec_1ee400ecdc379f1919f1c246",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-b6fc-77b8-84ec-f6728558da5a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with an island, stainless steel appliances, and white cabinets.",
        "public_id": "01a03756-b6fc-77b8-84ec-f6728558da5a",
        "storage_key": "property/5738458366607360/01a03756-b6fc-77b8-84ec-f6728558da5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Contemporary kitchen featuring a large island with seating, stainless steel appliances including a double oven and refrigerator, and sleek cabinetry.",
      "link": "false",
      "alt_text": "A kitchen with a marble countertop and a refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(6).jpg"
    },
    {
      "id": "ec_9fe22d676f618a8f0e1b1dd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-e75e-728b-8986-d43f93d8f9e3.webp",
      "image_media": {
        "alt_text": "Red classic car and modern sports car parked outside apartment buildings.",
        "public_id": "01a03756-e75e-728b-8986-d43f93d8f9e3",
        "storage_key": "property/5738458366607360/01a03756-e75e-728b-8986-d43f93d8f9e3.webp",
        "width": 3072,
        "height": 1730
      },
      "title": "Community",
      "description": "Classic car show featuring a red convertible and a modern sports car, set against the backdrop of upscale apartment buildings and landscaping.",
      "link": "false",
      "alt_text": "Two cars parked on a street with buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(29).jpg"
    },
    {
      "id": "ec_b2fdfebc9cb25ceb3195a997",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03756-dc35-723b-9669-e349a71905d5.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and kitchen view",
        "public_id": "01a03756-dc35-723b-9669-e349a71905d5",
        "storage_key": "property/5738458366607360/01a03756-dc35-723b-9669-e349a71905d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern fireplace, integrated kitchen, and dining space. Perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern living room with a yellow chair and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(7).jpg"
    },
    {
      "id": "ec_9cc15b94b9825ca4e502dc73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a1-7675-7096-ae8d-915a94864603.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large windows, view into bedroom",
        "public_id": "019d01a1-7675-7096-ae8d-915a94864603",
        "storage_key": "property/5738458366607360/019d01a1-7675-7096-ae8d-915a94864603.webp",
        "width": 2048,
        "height": 1363
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a fireplace, comfortable seating, and large windows with a view into the bedroom. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A modern living room with a dining table set for two.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(2).jpg"
    },
    {
      "id": "ec_2bb99aa742cf7fc6097cdfe4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a1-6863-77fb-aa4a-ae930e298d8a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and open living space.",
        "public_id": "019d01a1-6863-77fb-aa4a-ae930e298d8a",
        "storage_key": "property/5738458366607360/019d01a1-6863-77fb-aa4a-ae930e298d8a.webp",
        "width": 2048,
        "height": 1363
      },
      "title": "Apartment",
      "description": "A spacious and modern apartment kitchen featuring a large island with a double sink, stainless steel dishwasher, and pendant lighting. The open layout connects to a stylish living area with large windows and comfortable seating.",
      "link": "false",
      "alt_text": "A kitchen with a white counter top and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(1).jpg"
    },
    {
      "id": "ec_a457979f8ccb7dc196a7f35e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a1-a415-74f1-b901-17c112f85478.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with colorful facades and balconies, viewed from a street with landscaping and parked cars.",
        "public_id": "019d01a1-a415-74f1-b901-17c112f85478",
        "storage_key": "property/5738458366607360/019d01a1-a415-74f1-b901-17c112f85478.webp",
        "width": 1234,
        "height": 823
      },
      "title": "Community",
      "description": "Experience vibrant living in these contemporary apartment buildings, featuring striking architecture, balconies, and a well-landscaped streetscape.",
      "link": "false",
      "alt_text": "A street view of a residential area with buildings and parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(20).jpg"
    },
    {
      "id": "ec_69367c619b861622566fa7b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019df687-05fe-7369-9b5c-6a35bffacb91.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with festive holiday lights and decorative sculptures in a pedestrian plaza at dusk.",
        "public_id": "019df687-05fe-7369-9b5c-6a35bffacb91",
        "storage_key": "property/5738458366607360/019df687-05fe-7369-9b5c-6a35bffacb91.webp",
        "width": 1000,
        "height": 563
      },
      "title": "Community",
      "description": "Experience the vibrant community atmosphere with festive holiday decorations illuminating the exterior of our modern apartment buildings and surrounding plaza.",
      "link": "false",
      "alt_text": "A city street at night with a statue of a horse in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Woodin_Creek_Favorites%20(22).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_14221e2b-865e-42ce-9a87-ffaa07558cce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Kanishka Cuisine of India",
      "poi_type": "Restaurants",
      "poi_address": "16651 Redmond Wy Ste 180, Redmond, WA 98052, USA",
      "poi_short_description": "Broad menu featuring tandoori & veggie dishes in sizable restaurant with lunch buffet & happy hour.",
      "poi_long_description": "Diners say this Indian restaurant offers delicious, flavorful, and authentic food with generous portions, highlighting dishes like butter chicken, biryani, and naan. They also consistently praise the attentive, friendly, and professional staff, especially mentioning Sunny for exceptional service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-c9d2-711d-b393-a471611e095f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-c9d2-711d-b393-a471611e095f",
        "storage_key": "property/5738458366607360/01a03f05-c9d2-711d-b393-a471611e095f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kanishkaredmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5446967398759314703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kanishka-cuisine-of-india",
      "poi_latitude": "47.6724413",
      "poi_longitude": "-122.117766",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-869-9182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS6Nkq1ykFQRD7Uuav2Dl0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_c7afbdf0-c0a0-4701-aba8-a59c1c23deae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "DERU",
      "poi_type": "Restaurants",
      "poi_address": "723 9th Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Sleek market/eatery with pizza, sandwiches, salads & sweets made from locally sourced ingredients.",
      "poi_long_description": "People say this cafe offers delicious sandwiches, pizzas, and a wide variety of fresh, homemade pastries and cakes. They also highlight the friendly staff and the cozy, rustic-modern atmosphere. Visitors mention the food is consistently fresh, flavorful, and made with high-quality ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-bb62-7639-9894-c5a25292652c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-bb62-7639-9894-c5a25292652c",
        "storage_key": "property/5738458366607360/01a03f05-bb62-7639-9894-c5a25292652c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.derumarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755306842299324447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deru",
      "poi_latitude": "47.68201999999999",
      "poi_longitude": "-122.19416",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-298-0268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SkOAusSkFQRH1ho03tioGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_240c5c93-f147-4e5a-88b2-dad8e12dba06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12026 NE 124th St, Kirkland, WA 98034, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast-food restaurant offers delicious chicken sandwiches, waffle fries, and a variety of sauces, with many highlighting the consistently fresh and tasty food. They also mention the fast, friendly, and efficient service, even during busy hours. Guests appreciate the clean dining areas and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-b5d7-75aa-83c1-f043bb67ef13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-b5d7-75aa-83c1-f043bb67ef13",
        "storage_key": "property/5738458366607360/01a03f05-b5d7-75aa-83c1-f043bb67ef13.webp",
        "width": 1179,
        "height": 649
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/totem-lake?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17100142271408924863&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.7096168",
      "poi_longitude": "-122.1792938",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-803-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjyZqaYENkFQRv2j4n8voT-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3629f320-6cbf-475d-beec-02b8466dfd78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Zulu's Board Game Cafe",
      "poi_type": "Restaurants",
      "poi_address": "10234 Main St, Bothell, WA 98011, USA",
      "poi_short_description": "Informal hobby cafe with gaming-themed decor, serving booze & comfort food & hosting social events.",
      "poi_long_description": "People say this game store offers a wide selection of board games, card games, and accessories, with many available to try for free. They also highlight the delicious food, including burgers and poutine, and the friendly, knowledgeable staff. Visitors enjoy the cozy, tavern-like atmosphere, which is great for playing games with friends and family.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-bb6c-7721-8d0f-99d9f6bf340b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-bb6c-7721-8d0f-99d9f6bf340b",
        "storage_key": "property/5738458366607360/01a03f05-bb6c-7721-8d0f-99d9f6bf340b.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "http://www.zulusgames.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9762504998457654079&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "zulus-board-game-cafe",
      "poi_latitude": "47.7604864",
      "poi_longitude": "-122.2023845",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-818-8122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xqmaWkOkFQRPzsLd5Jie4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_25ebe1ad-0e7f-4a65-b654-66cbfd7fad8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Royal Biryani House",
      "poi_type": "Restaurants",
      "poi_address": "20611 Bothell Everett Hwy Apt G, Bothell, WA 98012, USA",
      "poi_short_description": "Curries, tandoori chicken & other Indian meals, plus a lunch buffet served in a relaxed dining room.",
      "poi_long_description": "People say this restaurant offers delicious and authentic biryani, with many highlighting the Bezawada, Goat Dum, and Chicken 65 biryanis, as well as flavorful appetizers like Bheemli Mirchi Chat. They also appreciate the generous portions, friendly staff, and good value for money.\n\nSome reviews mention the food can be extremely spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-b545-74e8-a117-fb8ee96a1dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-b545-74e8-a117-fb8ee96a1dc0",
        "storage_key": "property/5738458366607360/01a03f05-b545-74e8-a117-fb8ee96a1dc0.webp",
        "width": 1170,
        "height": 770
      },
      "poi_business_url": "https://royalbiryanihouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9773992328919521366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "royal-biryani-house",
      "poi_latitude": "47.8105539",
      "poi_longitude": "-122.2069738",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-481-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Z2osGsPkFQRVhikAj0ypIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_4da2a4a5-4ed2-4a96-8632-42ae42147cae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Redmond Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7525 166th Ave NE, Redmond, WA 98052, USA",
      "poi_short_description": "2-level outdoor shopping plaza with stores, restaurants, lodging & entertainment.",
      "poi_long_description": "People say this outdoor shopping center offers a great mix of shops and restaurants, with a clean, walkable layout and open spaces. They also highlight the pleasant, family-friendly atmosphere, convenient parking, and various community events.\n\nSome reviews mention the events can be poorly organized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-ca97-7468-a1ae-01190d62bf1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-ca97-7468-a1ae-01190d62bf1e",
        "storage_key": "property/5738458366607360/01a03f05-ca97-7468-a1ae-01190d62bf1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redmondtowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753620862211367335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redmond-town-center",
      "poi_latitude": "47.6703851",
      "poi_longitude": "-122.120144",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjYZ2uK9ykFQRp6GC602t3r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9783a579-c4a8-4ece-824b-8a90519cdc26",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12501 120th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of high-quality organic produce, meats, and specialty items, with a great bakery section. They also highlight the clean and organized environment, helpful staff, and convenient Amazon return service.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-c065-70ec-9823-049c1a7a2d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-c065-70ec-9823-049c1a7a2d1f",
        "storage_key": "property/5738458366607360/01a03f05-c065-70ec-9823-049c1a7a2d1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/kirkland?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001457",
      "poi_directions_map_url": "https://maps.google.com/?cid=4843404829819413838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.7116959",
      "poi_longitude": "-122.1800241",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-979-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9de-757c-8bf1-9d87ed028d2d",
        "storage_key": "property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRx4YnAQNkFQRTiXMAAg7N0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8b339d24-f09c-4e31-bbc4-82e047828f3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "18333 120th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this store offers a wide selection of home improvement products and supplies, with many items readily in stock. They also highlight the friendly, knowledgeable, and helpful staff, and appreciate the ample parking.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-c5ec-7098-8bf9-6ae7c76753dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-c5ec-7098-8bf9-6ae7c76753dc",
        "storage_key": "property/5738458366607360/01a03f05-c5ec-7098-8bf9-6ae7c76753dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Bothell/WA/Bothell/98011/4712?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11676615433004388263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "47.7600012",
      "poi_longitude": "-122.1778955",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-806-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHU85OX0OkFQRpw8S996rC6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_324d5010-936f-48e2-9072-4ecb338b722e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12520 Totem Lake Blvd NE Ste 116, Kirkland, WA 98034, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, cheeses, snacks, and frozen meals with short ingredient lists. They highlight the affordable prices, convenient location, and the store's clean and organized layout. They also like the friendly, helpful, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-8c28-719b-8cd8-fe4c5081d84d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-8c28-719b-8cd8-fe4c5081d84d",
        "storage_key": "property/5738458366607360/019d01a2-8c28-719b-8cd8-fe4c5081d84d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/kirkland/132/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15173403197318358355&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.71191049999999",
      "poi_longitude": "-122.1805508",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-814-9181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9de-757c-8bf1-9d87ed028d2d",
        "storage_key": "property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bkSBoQNkFQRU-Xv2dDBktI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_732e5adc-4465-48a3-9637-ac6dad547d41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 120th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this store offers a wide selection of groceries, housewares, and clothing, with many sale items and quality produce. Visitors also highlight the friendly and helpful staff, convenient parking, and clean, well-organized environment.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-b434-70e2-82ae-e7f1656c241d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-b434-70e2-82ae-e7f1656c241d",
        "storage_key": "property/5738458366607360/01a03f05-b434-70e2-82ae-e7f1656c241d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/kirkland/fred-meyer-kirkland/701/00391?cid=loc_70100391_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642218835222015052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.7078604",
      "poi_longitude": "-122.184222",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-820-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9de-757c-8bf1-9d87ed028d2d",
        "storage_key": "property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgevtloANkFQRTCzdbFRVyhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8bc50b41-2828-4fab-8b9e-8d125b3d928e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "University of Washington Bothell",
      "poi_type": "Education",
      "poi_address": "17927 113th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-cb5a-757e-9c31-37012ab6274d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-cb5a-757e-9c31-37012ab6274d",
        "storage_key": "property/5738458366607360/01a03f05-cb5a-757e-9c31-37012ab6274d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uwb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14107547568998928606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-bothell",
      "poi_latitude": "47.7584761",
      "poi_longitude": "-122.190891",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-352-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9d8-749c-a557-54a78f296c65",
        "storage_key": "property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46EtkWAOkFQR3lAb3sQTyMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_20bcefba-1df7-405d-9b1d-d0e2f745a7cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Lake Washington Institute of Technology",
      "poi_type": "Education",
      "poi_address": "11605 132nd Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-d0c7-755f-a5a6-1ab4f86029b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-d0c7-755f-a5a6-1ab4f86029b1",
        "storage_key": "property/5738458366607360/01a03f05-d0c7-755f-a5a6-1ab4f86029b1.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.lwtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688448915436613948&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-washington-institute-of-technology",
      "poi_latitude": "47.7046059",
      "poi_longitude": "-122.1669903",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-739-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9d8-749c-a557-54a78f296c65",
        "storage_key": "property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeVTZ7XkNkFQRPDEe_fRIdIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7688387b-e16f-4ed2-828e-fc7980f932e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Redmond Library",
      "poi_type": "Education",
      "poi_address": "15990 NE 85th St, Redmond, WA 98052, USA",
      "poi_short_description": "Warm, carpeted library featuring a large selection of books and DVDs, plus computers, quiet areas and free WiFi.",
      "poi_long_description": "People say this library offers a wide variety of books, magazines, and computers with fast Wi-Fi, along with comfortable seating and charging ports. They also highlight the clean, quiet atmosphere and the availability of meeting rooms and community events. Visitors appreciate the friendly, helpful, and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-c83f-7709-aad2-a8e95ea3b589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-c83f-7709-aad2-a8e95ea3b589",
        "storage_key": "property/5738458366607360/01a03f05-c83f-7709-aad2-a8e95ea3b589.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/redmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10162122076226988230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redmond-library",
      "poi_latitude": "47.6789086",
      "poi_longitude": "-122.1280775",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-885-1861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-1336-71cc-87ef-c0fe7207a3dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f06-1336-71cc-87ef-c0fe7207a3dd",
        "storage_key": "property/5738458366607360/01a03f06-1336-71cc-87ef-c0fe7207a3dd.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJR0c4XE0NkFQRxiiq5S8cB40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ac8ea1d3-921c-49b8-84ee-1da1f5f67a7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Kirkland Library",
      "poi_type": "Education",
      "poi_address": "308 Kirkland Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Well-maintained branch of King County libraries, featuring a children's zone, computers and free parking.",
      "poi_long_description": "People say this library offers a great environment for studying with excellent facilities, a large, quiet space, and a wide selection of interesting books. They also highlight the convenient 24/7 book hold lockers and ample parking. Visitors appreciate the friendly, helpful, and patient staff, as well as the superb atmosphere with natural light and views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-c601-7348-8ce2-37ffc5c0578b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-c601-7348-8ce2-37ffc5c0578b",
        "storage_key": "property/5738458366607360/01a03f05-c601-7348-8ce2-37ffc5c0578b.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/kirkland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13242990867223347738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kirkland-library",
      "poi_latitude": "47.6760175",
      "poi_longitude": "-122.2029286",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-822-2459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-1336-71cc-87ef-c0fe7207a3dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f06-1336-71cc-87ef-c0fe7207a3dd",
        "storage_key": "property/5738458366607360/01a03f06-1336-71cc-87ef-c0fe7207a3dd.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ2V7abt0SkFQRGgKXhAeOyLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_36d0c75e-d328-4e3f-8c37-5b2f97d1d188",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Cascadia College",
      "poi_type": "Education",
      "poi_address": "18345 Campus Way NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-d014-759f-950e-034182419ff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-d014-759f-950e-034182419ff2",
        "storage_key": "property/5738458366607360/01a03f05-d014-759f-950e-034182419ff2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cascadia.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2670569366650101442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cascadia-college",
      "poi_latitude": "47.760928",
      "poi_longitude": "-122.1913857",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-352-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9d8-749c-a557-54a78f296c65",
        "storage_key": "property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY8-apmUOkFQRwh44j7DEDyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3d62c5f8-8543-4d2e-9ed4-df190c3cee78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Elevated Sportz Trampoline Park & Event Center",
      "poi_type": "Entertainment",
      "poi_address": "18311 Bothell Everett Hwy #140, Bothell, WA 98012, USA",
      "poi_short_description": "Fun venue featuring trampoline courts and a ninja course, plus play areas for toddlers and kids.",
      "poi_long_description": "People say this trampoline park offers a wide variety of activities, including trampolines, dodgeball, a ninja course, and an arcade, making it a great place for kids to have fun. They also highlight the friendly and helpful staff, convenient parking, and the value of visiting on weekday mornings.\n\nSome reviews mention the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-d6bd-713c-9a0f-1024f3195ea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-d6bd-713c-9a0f-1024f3195ea4",
        "storage_key": "property/5738458366607360/01a03f05-d6bd-713c-9a0f-1024f3195ea4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elevatedsportz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16424883574067260876&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elevated-sportz-trampoline-park--event-center",
      "poi_latitude": "47.8318555",
      "poi_longitude": "-122.2078521",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-949-4488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXaWT3_kFkFQRzG1tfZbo8OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_490246ac-8539-4b11-9d64-20df13458e56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Pop Keeney Stadium",
      "poi_type": "Entertainment",
      "poi_address": "9809 NE 188th St, Bothell, WA 98011, USA",
      "poi_short_description": "High school and other sporting events, plus graduations, are held at this stadium.",
      "poi_long_description": "People say this stadium offers excellent covered seating with close-up views of the field, which features exquisite turf. Visitors also highlight the wheelchair accessibility and the well-maintained facilities. They also mention the availability of parking, including a nearby city hall garage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-f53e-700c-bfcb-02b3d490d23c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-f53e-700c-bfcb-02b3d490d23c",
        "storage_key": "property/5738458366607360/01a03f05-f53e-700c-bfcb-02b3d490d23c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nsd.org/schools/enrichment-activities/athletics/attending-a-sporting-event",
      "poi_directions_map_url": "https://maps.google.com/?cid=5132767412481085808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pop-keeney-stadium",
      "poi_latitude": "47.76314900000001",
      "poi_longitude": "-122.2112143",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-408-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd6b-72e1-a262-1b27f953aa24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd6b-72e1-a262-1b27f953aa24",
        "storage_key": "property/5738458366607360/019d01a2-bd6b-72e1-a262-1b27f953aa24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3WMRuUEOkFQRcNGiX8RAO0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_68191c8c-ebde-476a-9ff5-5ae266efb9d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Walter L. Seabloom Field",
      "poi_type": "Entertainment",
      "poi_address": "17272 NE 104th St, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-e4bd-729a-8509-53ad76b9c92a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-e4bd-729a-8509-53ad76b9c92a",
        "storage_key": "property/5738458366607360/01a03f05-e4bd-729a-8509-53ad76b9c92a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://rhs.lwsd.org/athletics/stadium-calendar",
      "poi_directions_map_url": "https://maps.google.com/?cid=14895864739562054015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walter-l-seabloom-field",
      "poi_latitude": "47.6941606",
      "poi_longitude": "-122.1097894",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-936-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd6b-72e1-a262-1b27f953aa24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd6b-72e1-a262-1b27f953aa24",
        "storage_key": "property/5738458366607360/019d01a2-bd6b-72e1-a262-1b27f953aa24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6eT-S8NkFQRf-HcFw--uM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_29e5e922-6db5-4475-a387-3d85c4ec985e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Bothell Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "9919 NE 180th St, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-dd5a-71e8-9324-58bed25bfc6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-dd5a-71e8-9324-58bed25bfc6f",
        "storage_key": "property/5738458366607360/01a03f05-dd5a-71e8-9324-58bed25bfc6f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bothellhistoricalmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13425983682189658429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bothell-historical-museum",
      "poi_latitude": "47.7582422",
      "poi_longitude": "-122.2076753",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd58-70bc-ad93-1cf43dcbb3e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd58-70bc-ad93-1cf43dcbb3e3",
        "storage_key": "property/5738458366607360/019d01a2-bd58-70bc-ad93-1cf43dcbb3e3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0XCamsOkFQRPQkbaQatUro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7cb7fc79-fcd5-489e-9225-f49bb86e83fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "The Bench™",
      "poi_type": "Entertainment",
      "poi_address": "19845-20099 47th Ave NE, Lake Forest Park, WA 98155, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-f017-71ae-95d8-efee8cc8b277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-f017-71ae-95d8-efee8cc8b277",
        "storage_key": "property/5738458366607360/01a03f05-f017-71ae-95d8-efee8cc8b277.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16292010156088681781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-bench",
      "poi_latitude": "47.7727927",
      "poi_longitude": "-122.2796419",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-133e-77f4-a0e0-6a8788e692d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f06-133e-77f4-a0e0-6a8788e692d7",
        "storage_key": "property/5738458366607360/01a03f06-133e-77f4-a0e0-6a8788e692d7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Zu0bAARkFQRNeW4DuvYGOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_37487feb-1def-4ee4-9e62-92d57b5a2345",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12321 120th Pl NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Friendly, health-focused chain with a pool and strength-training equipment.",
      "poi_long_description": "Reviewers consistently praise this gym for its well-maintained pool and sauna, along with its friendly and helpful staff.\n\nOther reviews mention the gym can be poorly maintained and some of the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-ebd3-754b-ab51-7f680823ee97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-ebd3-754b-ab51-7f680823ee97",
        "storage_key": "property/5738458366607360/01a03f05-ebd3-754b-ab51-7f680823ee97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=694&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4987240807792720913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.70885089999999",
      "poi_longitude": "-122.1797427",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-298-1331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZdPp4ENkFQRETzRVRc9NkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6e60279e-cf65-4433-b07a-8587a839f195",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "18006 120th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym is clean, offers a wide variety of equipment, and has friendly, helpful staff who create a welcoming atmosphere.\n\nOther reviews mention the facility can be neglected and not truly 24 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-eb6f-703c-9c25-8ec7264ad945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-eb6f-703c-9c25-8ec7264ad945",
        "storage_key": "property/5738458366607360/01a03f05-eb6f-703c-9c25-8ec7264ad945.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/bothell-wa/bothell-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=9734597478713896484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.7587853",
      "poi_longitude": "-122.1730193",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-492-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwODg30OkFQRJK4nrtQ8GIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4e7b8b31-c4f8-41fc-9e55-4246c15faff0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "24122 Bothell Everett Hwy, Bothell, WA 98021, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers praise this gym for its wide variety of equipment, friendly staff, and a welcoming, judgment-free environment.\n\nOther reviews mention canceling memberships can be difficult and the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-e728-725f-bd92-258fdcb0228a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-e728-725f-bd92-258fdcb0228a",
        "storage_key": "property/5738458366607360/01a03f05-e728-725f-bd92-258fdcb0228a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bothell-north-wa?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17509364216771361817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.778071",
      "poi_longitude": "-122.2200713",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-384-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSmnAUEPkFQRGbyXj_zB_fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_9fddcb0c-02ce-4a93-bf5a-6a5fc082b222",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Pacific Reign Gymnastics - Woodinville",
      "poi_type": "Health and Wellness",
      "poi_address": "12728 NE 178th St, Woodinville, WA 98072, USA",
      "poi_short_description": "Training center providing a range of gymnastics programs for all ages and skill levels.",
      "poi_long_description": "People say this gymnastics gym offers well-organized classes and competition programs for various age groups, including a separate section for toddlers. They also highlight the clean, bright, and well-maintained facility, along with convenient parking. Guests mention the coaches are professional, caring, and skilled at motivating children, and the front desk staff are friendly and helpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-e716-724c-b034-d87e60d4f14e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-e716-724c-b034-d87e60d4f14e",
        "storage_key": "property/5738458366607360/01a03f05-e716-724c-b034-d87e60d4f14e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pacificreign.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=257775700063114341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-reign-gymnastics---woodinville",
      "poi_latitude": "47.75671029999999",
      "poi_longitude": "-122.1690099",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-488-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9d8-749c-a557-54a78f296c65",
        "storage_key": "property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkV2yoPQPkFQRZVT9KaLNkwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9b301d5b-ef5b-4318-afbf-6fd3dba0d269",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital Kirkland",
      "poi_type": "Health and Wellness",
      "poi_address": "11814 115th Ave NE Bldg. J, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-9fb8-772b-8a85-5d0f2817f0f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-9fb8-772b-8a85-5d0f2817f0f5",
        "storage_key": "property/5738458366607360/019d01a2-9fb8-772b-8a85-5d0f2817f0f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/kirkland-wa/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4372267609901325&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital-kirkland",
      "poi_latitude": "47.70672",
      "poi_longitude": "-122.1871076",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-823-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTH1D38SkFQRDUnA4Y2IDwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ad9f67ff-ccbf-4911-bb48-aaa07b57f2f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Cut + Flow Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "19122 Beardslee Blvd #101, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this studio offers a wide variety of yoga and Pilates classes, including reformer Pilates, with diverse instructors and varying styles. They also highlight the clean, fresh, and well-kept environment, noting it doesn't smell like a typical gym. Guests mention the staff are welcoming, motivating, and genuinely invested in creating a positive space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-e47b-751b-a5ad-64299ecef5b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-e47b-751b-a5ad-64299ecef5b6",
        "storage_key": "property/5738458366607360/01a03f05-e47b-751b-a5ad-64299ecef5b6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://cutandflowstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7733266919820792117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cut--flow-studio",
      "poi_latitude": "47.7665703",
      "poi_longitude": "-122.1912446",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-908-7297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRz6QFYPkFQRNZEyfUoVUms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7f26f095-7692-4699-8fb7-147cda6c5f6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Center for Bird and Exotic Animal Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "11401 NE 195th St, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-a17c-711d-9c6a-bd082510a165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-a17c-711d-9c6a-bd082510a165",
        "storage_key": "property/5738458366607360/019d01a2-a17c-711d-9c6a-bd082510a165.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theexoticvet.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg3NTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11442927624712957747&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "center-for-bird-and-exotic-animal-medicine",
      "poi_latitude": "47.7686268",
      "poi_longitude": "-122.1878546",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-486-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVq5weMPkFQRMy-FJQxyzZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ffe89f2e-4c9f-44ee-82aa-de1359dd5d10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "[solidcore] Totem Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "12670 120th Ave NE Ste 182, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers challenging, low-impact workouts that deliver results, with modern equipment and clean, well-maintained facilities. They also highlight the encouraging and knowledgeable staff, convenient parking, and supportive community.\n\nSome reviews mention the equipment can be faulty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-eb82-7668-b623-e37149d59d1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-eb82-7668-b623-e37149d59d1e",
        "storage_key": "property/5738458366607360/01a03f05-eb82-7668-b623-e37149d59d1e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://solidcore.co/studios/totem-lake?siteId=5723430&locationId=6&utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6925043310392766722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidcore-totem-lake",
      "poi_latitude": "47.7134699",
      "poi_longitude": "-122.1804695",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-590-6562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9d8-749c-a557-54a78f296c65",
        "storage_key": "property/5738458366607360/019d01a2-b9d8-749c-a557-54a78f296c65.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ69cppcANkFQRAvEnSjOyGmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_704c844e-3f81-486c-b89f-270007b2538a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Columbia Athletic Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "11450 98th Ave NE, Kirkland, WA 98033, USA",
      "poi_short_description": "Fitness center with a pool, basketball and squash courts, a sauna, and group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-f406-7159-b421-2485ea8ac7d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-f406-7159-b421-2485ea8ac7d9",
        "storage_key": "property/5738458366607360/01a03f05-f406-7159-b421-2485ea8ac7d9.webp",
        "width": 1280,
        "height": 856
      },
      "poi_business_url": "http://columbiaathletic.com/locations/juanita-bay/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860596661158713137&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-athletic-clubs",
      "poi_latitude": "47.7035448",
      "poi_longitude": "-122.2100419",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-821-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPyQMlGYSkFQRMZccWqEoHNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f86e331-0664-42d8-8594-faf4e1b0f646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "EvergreenHealth Medical Center Kirkland",
      "poi_type": "Health and Wellness",
      "poi_address": "12040 NE 128th St, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-f145-76bc-a3c2-547488b424bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-f145-76bc-a3c2-547488b424bc",
        "storage_key": "property/5738458366607360/01a03f05-f145-76bc-a3c2-547488b424bc.webp",
        "width": 600,
        "height": 563
      },
      "poi_business_url": "https://www.evergreenhealth.com/locations/locations-profile/evergreenhealth-medical-center/?utm_source=EH-MEDCENTER&utm_campaign=Local-Listings&utm_medium=Google-My-Business",
      "poi_directions_map_url": "https://maps.google.com/?cid=14406417902947637237&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "evergreenhealth-medical-center-kirkland",
      "poi_latitude": "47.7156418",
      "poi_longitude": "-122.1795593",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-899-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bda0-772a-b9af-1533783338bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bda0-772a-b9af-1533783338bb",
        "storage_key": "property/5738458366607360/019d01a2-bda0-772a-b9af-1533783338bb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-7eSYUNkFQR9ZcFF8Hg7cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4180934d-64f9-44ee-a5d1-8bb84b3c1a20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Swedish Redmond Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "18100 NE Union Hill Rd, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-f7f6-7229-819c-18911353290f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-f7f6-7229-819c-18911353290f",
        "storage_key": "property/5738458366607360/01a03f05-f7f6-7229-819c-18911353290f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.swedish.org/locations/redmond-campus?Is=location&y_source=1_OTU3Njc0Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9097953388022222019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "swedish-redmond-campus",
      "poi_latitude": "47.6763693",
      "poi_longitude": "-122.0990518",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-320-5190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bda0-772a-b9af-1533783338bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bda0-772a-b9af-1533783338bb",
        "storage_key": "property/5738458366607360/019d01a2-bda0-772a-b9af-1533783338bb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_GcqMhykFQRw0wgRGdsQn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4f472ed4-d1e1-445a-8266-432ef0f337ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Juanita Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9703 NE Juanita Dr, Kirkland, WA 98034, USA",
      "poi_short_description": "This park features a sandy beach, volleyball & tennis courts, ball fields, fishing & a playground.",
      "poi_long_description": "People say this park offers a beautiful beach, a large playground for kids, and rentals for paddleboards and kayaks. Visitors also highlight the clean and well-maintained restrooms and grounds. They also like the peaceful atmosphere and the scenic views, especially at sunset.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-00d2-7463-b806-dc90901c5238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-00d2-7463-b806-dc90901c5238",
        "storage_key": "property/5738458366607360/01a03f06-00d2-7463-b806-dc90901c5238.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklandwa.gov/depart/parks/Parks_and_Open_Spaces/Online_Parks_Guide/Parks_Pop-up_Main/Parks_and_Community_Services__Juanita_Beach_Park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784180254516446732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "juanita-beach-park",
      "poi_latitude": "47.7046205",
      "poi_longitude": "-122.2147696",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c260-76f8-a30e-9eabe7088e34",
        "storage_key": "property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSZt12cSkFQRDAYwNVCsDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aa3be6ba-96e5-4195-91a0-ce9076acfe0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Grass Lawn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7031 148th Ave NE, Redmond, WA 98052, USA",
      "poi_short_description": "Tree-filled public park with tennis & basketball courts, sports fields & an extensive playground.",
      "poi_long_description": "People say this park offers multiple playgrounds, including climbing rocks and rope bridges, along with various sports fields and courts for tennis, basketball, baseball, and soccer. Visitors also highlight the well-maintained facilities, clean restrooms, and ample open spaces for walking and relaxation. They also appreciate the convenient parking options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0224-743c-9090-5a3cdd5a64f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0224-743c-9090-5a3cdd5a64f7",
        "storage_key": "property/5738458366607360/01a03f06-0224-743c-9090-5a3cdd5a64f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.redmond.gov/facilities/facility/details/grasslawnpark-62",
      "poi_directions_map_url": "https://maps.google.com/?cid=3803125024226082345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grass-lawn-park",
      "poi_latitude": "47.6681769",
      "poi_longitude": "-122.1461102",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-556-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c260-76f8-a30e-9eabe7088e34",
        "storage_key": "property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5Tea1RtkFQRKf5kSQ9qxzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dd453c0a-c1f1-4fe5-9d97-8a0fa3051967",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Willows Run Golf Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10402 Willows Rd NE, Redmond, WA 98052, USA",
      "poi_short_description": "Large golf complex featuring 2 18-hole courses, a 9-hole course, a putting course & more.",
      "poi_long_description": "Visitors say this golf complex offers a variety of courses, including two 18-hole options, a 9-hole par three, and a fun mini golf course, with greens often in excellent condition. They also highlight the reasonable prices, friendly staff, and the relaxed atmosphere.\n\nSome reviews mention the course conditions can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f05-fd74-744d-a7b9-97f4595ab2e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f05-fd74-744d-a7b9-97f4595ab2e0",
        "storage_key": "property/5738458366607360/01a03f05-fd74-744d-a7b9-97f4595ab2e0.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://willowsrun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2205825855337394888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "willows-run-golf-complex",
      "poi_latitude": "47.69020949999999",
      "poi_longitude": "-122.1491353",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-883-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c277-7779-ab88-c49033c1b596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c277-7779-ab88-c49033c1b596",
        "storage_key": "property/5738458366607360/019d01a2-c277-7779-ab88-c49033c1b596.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3D3UlwNkFQRyPLBr-2qnB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_89c14999-e5d9-4d30-b2e2-906dd0ffe40a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Saint Edward State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14445 Juanita Dr NE, Kenmore, WA 98028, USA",
      "poi_short_description": "Once a seminary, the day-use park offers historic architecture & lakeshore space for nature study.",
      "poi_long_description": "Visitors say this park offers a wide variety of well-maintained hiking and mountain biking trails, with options for all skill levels, and features a large, unique playground for kids. They also highlight the beautiful scenery, including views of Lake Washington, and appreciate the clean restrooms and ample parking. Guests mention the staff at the lodge and restaurants are fantastic and provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-045f-76c0-a173-171899e23bc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-045f-76c0-a173-171899e23bc2",
        "storage_key": "property/5738458366607360/01a03f06-045f-76c0-a173-171899e23bc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://parks.state.wa.us/577/Saint-Edward",
      "poi_directions_map_url": "https://maps.google.com/?cid=8750157182089164838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-edward-state-park",
      "poi_latitude": "47.7313406",
      "poi_longitude": "-122.2550771",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 425-823-2992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c260-76f8-a30e-9eabe7088e34",
        "storage_key": "property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9OZpYwRkFQRJvhBx5jNbnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_209b8eb3-aade-45b3-8f7e-a82ca941dc3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Log Boom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17415 61st Ave NE, Kenmore, WA 98028, USA",
      "poi_short_description": "Playground, picnic tables and sandy beach area for swimming, paddling and boating.",
      "poi_long_description": "Visitors say this park features a lovely sandy beach, a playground, and a pier, making it ideal for families and children. They also highlight the well-maintained walking and biking trails, which connect to longer routes and offer opportunities for bird watching. Guests mention the availability of restrooms, drinking fountains, and dog waste bags, along with convenient kayak and paddleboard rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-000d-75fa-b36f-916aa5511af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-000d-75fa-b36f-916aa5511af0",
        "storage_key": "property/5738458366607360/01a03f06-000d-75fa-b36f-916aa5511af0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kenmorewa.gov/our-city/city-parks-trails/-item-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=165211858373629103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "log-boom-park",
      "poi_latitude": "47.7577462",
      "poi_longitude": "-122.26431",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-398-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c260-76f8-a30e-9eabe7088e34",
        "storage_key": "property/5738458366607360/019d01a2-c260-76f8-a30e-9eabe7088e34.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcfcRtARkFQRr9QKU0_zSgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ea127c56-50a0-4c36-ba6b-1ac655168efb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Kenmore Air - Lake Washington",
      "poi_type": "Transportation & Transit",
      "poi_address": "6321 NE 175th St, Kenmore, WA 98028, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this seaplane base offers amazing scenic flights and convenient transportation to various islands, with many appreciating the unique experience of flying in radial engine seaplanes. They also highlight the easy check-in process, ample parking, and the helpful, professional staff. Guests mention the experienced pilots and the overall smooth, enjoyable flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-03b7-717d-8661-ef91ec920d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-03b7-717d-8661-ef91ec920d5b",
        "storage_key": "property/5738458366607360/01a03f06-03b7-717d-8661-ef91ec920d5b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kenmoreair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813633346698526503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kenmore-air---lake-washington",
      "poi_latitude": "47.7569221",
      "poi_longitude": "-122.2579096",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 866-435-9524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-c29d-76b1-964b-7f492cf4e9d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-c29d-76b1-964b-7f492cf4e9d6",
        "storage_key": "property/5738458366607360/019d01a2-c29d-76b1-964b-7f492cf4e9d6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzRmrNsRkFQRJ7-gRXIGVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d8bd27e9-d79e-4c11-ba98-42b17e8212bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Downtown Redmond",
      "poi_type": "Transportation & Transit",
      "poi_address": "Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0672-75ea-a862-48e124417367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0672-75ea-a862-48e124417367",
        "storage_key": "property/5738458366607360/01a03f06-0672-75ea-a862-48e124417367.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17985969006092120986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-redmond",
      "poi_latitude": "47.67165",
      "poi_longitude": "-122.11848",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-134c-748e-a1f1-238cc7c165ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f06-134c-748e-a1f1-238cc7c165ef",
        "storage_key": "property/5738458366607360/01a03f06-134c-748e-a1f1-238cc7c165ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZs8PLBykFQRmnNObYT_mvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0074edac-8dae-4477-bf01-5be307ccce19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Google Building C",
      "poi_type": "Major Employers & Offices",
      "poi_address": "747 6th St South Building C, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0721-73dd-a743-39ecd531bc2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0721-73dd-a743-39ecd531bc2e",
        "storage_key": "property/5738458366607360/01a03f06-0721-73dd-a743-39ecd531bc2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10721464933427837784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-building-c",
      "poi_latitude": "47.6701428",
      "poi_longitude": "-122.1974489",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTxax6NoSkFQRWPvFXI1LypQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7aeafb7c-cde2-4121-b00e-8f8bc91a215a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Google Building D",
      "poi_type": "Major Employers & Offices",
      "poi_address": "451 7th Ave S, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0996-7232-a948-b0cea57dc865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0996-7232-a948-b0cea57dc865",
        "storage_key": "property/5738458366607360/01a03f06-0996-7232-a948-b0cea57dc865.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://google.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10141625052609526091&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-building-d",
      "poi_latitude": "47.6693012",
      "poi_longitude": "-122.1993529",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXxfLXkTkFQRSzn-sUBKvow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d9415743-0ca6-46cc-84ab-603051be4164",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Google Kirkland - Kirkland Urban",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 Urban Plz Suite#223, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-09fa-74ba-b701-38aec376829f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-09fa-74ba-b701-38aec376829f",
        "storage_key": "property/5738458366607360/01a03f06-09fa-74ba-b701-38aec376829f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://about.google/company-info/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12392096200761415899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-kirkland---kirkland-urban",
      "poi_latitude": "47.6775887",
      "poi_longitude": "-122.1992122",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0JJdpgTkFQR2xjapNaR-as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ca6bfbad-4e86-4cb7-8315-11e2ac09e941",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Stryker",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11811 Willows Rd NE, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0ca4-76c5-b185-f94294610f95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0ca4-76c5-b185-f94294610f95",
        "storage_key": "property/5738458366607360/01a03f06-0ca4-76c5-b185-f94294610f95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://careers.stryker.com/washington-redmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3494411947184774293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stryker",
      "poi_latitude": "47.70731139999999",
      "poi_longitude": "-122.1561536",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-442-1142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxmlUXENkFQRlVzU2ialfjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_95448825-53a3-4ee5-8642-8a7fb60d6ded",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Philips Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22100 Bothell Everett Hwy, Bothell, WA 98021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f06-0c47-7018-b7ff-611cbd85fbcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f06-0c47-7018-b7ff-611cbd85fbcc",
        "storage_key": "property/5738458366607360/01a03f06-0c47-7018-b7ff-611cbd85fbcc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.healthcare.philips.com/main?link_origin=global_en_HC%3Amain%3Aheader-healthcare",
      "poi_directions_map_url": "https://maps.google.com/?cid=3444942013548930731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philips-healthcare",
      "poi_latitude": "47.7986093",
      "poi_longitude": "-122.215873",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-744-5477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_1KSwkPkFQRqyZnXYLkzi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d651ead3-a6d0-499d-a5fe-7444c10b1675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Haggen",
      "poi_type": "Shopping & Retail",
      "poi_address": "17641 Garden Way NE, Woodinville, WA 98072, USA",
      "poi_short_description": "Comprehensive grocery store offering extensive fresh produce and bakery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, daily baked breads, and unique products not found elsewhere. They also highlight the clean environment, friendly staff, and great deli options, including sandwiches and a hot bar.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f07-2b03-763f-9c6f-8779f6270b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f07-2b03-763f-9c6f-8779f6270b42",
        "storage_key": "property/5738458366607360/01a03f07-2b03-763f-9c6f-8779f6270b42.webp",
        "width": 1200,
        "height": 884
      },
      "poi_business_url": "https://local.haggen.com/wa/woodinville/17641-garden-way-ne.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996016259829561398&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "haggen",
      "poi_latitude": "47.7557523",
      "poi_longitude": "-122.1573512",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 425-398-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9de-757c-8bf1-9d87ed028d2d",
        "storage_key": "property/5738458366607360/019d01a2-b9de-757c-8bf1-9d87ed028d2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQB2wikMkFQRNngLhTZGsxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_618ee842-2f6b-46f7-bbdf-b7cab0b9a1d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Sidekick Coffee",
      "poi_type": "Shopping & Retail",
      "poi_address": "17255 135th Ave NE Ste 1020, Woodinville, WA 98072, USA",
      "poi_short_description": "Inviting local coffee shop serving specialty espresso drinks and fresh pastries.",
      "poi_long_description": "People say this coffee shop offers delicious matcha lattes, pastries, and hot sandwiches. They highlight the warm and inviting atmosphere, and the friendly and personable service. They also like the convenient parking and free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d12-595d-72bf-999d-78becafe712d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d12-595d-72bf-999d-78becafe712d",
        "storage_key": "property/5738458366607360/01a11d12-595d-72bf-999d-78becafe712d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://sidekick.coffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13666681662597424289&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sidekick-coffee",
      "poi_latitude": "47.752347",
      "poi_longitude": "-122.15928479999998",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "1",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-949-7422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f07-7e42-723c-95a3-59e09a97ee07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f07-7e42-723c-95a3-59e09a97ee07",
        "storage_key": "property/5738458366607360/01a03f07-7e42-723c-95a3-59e09a97ee07.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ34CB1DsNkFQRoeR2HZDOqb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7d50f14e-6ed2-4996-8ddb-ec957e9d231b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Woodin Creek Kitchen & Tap",
      "poi_type": "Restaurants",
      "poi_address": "13550 NE Village Square Dr #1010, Woodinville, WA 98072, USA",
      "poi_short_description": "Airy, industrial restaurant with hearty grub, 30+ beers on tap & cocktails, plus TV sports & patios.",
      "poi_long_description": "Guests consistently praise this restaurant for its wide variety of menu options, including delicious burgers, mussels, and Brussels sprouts, as well as good gluten-free and kids' choices. They also highlight the friendly staff, great atmosphere, and convenient parking.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-985e-75bf-a23d-449807a88f24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-985e-75bf-a23d-449807a88f24",
        "storage_key": "property/5738458366607360/01a11d8b-985e-75bf-a23d-449807a88f24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.woodincreekkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7425801206232005910&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodin-creek-kitchen--tap",
      "poi_latitude": "47.7523754",
      "poi_longitude": "-122.1588963",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "1",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-215-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyfhtQINkFQRFj0gftq-DWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e78792f6-ff92-49af-90b4-7749feba31a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Brix Wine Cafe",
      "poi_type": "Restaurants",
      "poi_address": "13550 NE Village Square Dr Ste 1050, Woodinville, WA 98072, USA",
      "poi_short_description": "Welcoming restaurant offering an extensive wine selection and diverse American plates like pappardelle pasta and truffle fries.",
      "poi_long_description": "Diners like this restaurant's delicious and flavorful food, including perfectly cooked steaks, juicy burgers, and tasty desserts. They also highlight the warm, friendly, and attentive service from the staff. Guests mention the fair prices for the quality, making it an excellent value, and appreciate the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f07-1b66-728e-a1cb-9c41e7d8ad15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f07-1b66-728e-a1cb-9c41e7d8ad15",
        "storage_key": "property/5738458366607360/01a03f07-1b66-728e-a1cb-9c41e7d8ad15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brixwinecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11326053420878225154&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brix-wine-cafe",
      "poi_latitude": "47.7519984",
      "poi_longitude": "-122.158825",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "1",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-242-0280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5kgA5wNkFQRAl-LCpQ5Lp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d59db885-7c06-4ea4-b471-e8d3743331f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Rusty Pelican Cafe Woodinville",
      "poi_type": "Restaurants",
      "poi_address": "13590 NE Village Square Dr Ste 1060, Woodinville, WA 98072, USA",
      "poi_short_description": "Upscale Woodinville brunch destination serving breakfast staples like eggs benedict, pancakes, and biscuits and gravy.",
      "poi_long_description": "Diners like this cafe's delicious coffee, fresh pastries, and a wide variety of breakfast and brunch options, including excellent crepes and coffee cakes. They also highlight the friendly, attentive service and the pleasant, clean atmosphere.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-96d2-72eb-a5cd-543f792ae6a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-96d2-72eb-a5cd-543f792ae6a3",
        "storage_key": "property/5738458366607360/01a11d8b-96d2-72eb-a5cd-543f792ae6a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rustypelicancafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5539751145592585726&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rusty-pelican-cafe-woodinville",
      "poi_latitude": "47.751836999999995",
      "poi_longitude": "-122.15843849999997",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-286-6660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9db-77de-8985-da1815c4bae2",
        "storage_key": "property/5738458366607360/019d01a2-b9db-77de-8985-da1815c4bae2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWXkMrMNkFQR_v0b6VAm4Uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b208987a-5913-40d0-b813-735b6be48402",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Swanky Scoop",
      "poi_type": "Shopping & Retail",
      "poi_address": "13550 NE Village Square Dr #1030, Woodinville, WA 98072, USA",
      "poi_short_description": "Artisanal ice cream shop featuring rotating creative flavors and extensive vegan options.",
      "poi_long_description": "People say this ice cream shop offers a wide variety of unique and delicious flavors, including many vegan and gluten-free options, and they appreciate the clear allergen labeling. They also highlight the generous portion sizes for the price and the clean, well-maintained restrooms. Visitors mention the staff are friendly, patient, and knowledgeable, providing excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-92d7-752d-a0f9-8afbf015f2b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-92d7-752d-a0f9-8afbf015f2b4",
        "storage_key": "property/5738458366607360/01a11d8b-92d7-752d-a0f9-8afbf015f2b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://swankyscoop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=921630100997900539&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "swanky-scoop",
      "poi_latitude": "47.752178199999996",
      "poi_longitude": "-122.158911",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "1",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-659-3534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi9tnNcINkFQR-4hJoLFJygw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_b1b778ce-f9f1-4cce-afe0-7f3222951e1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "13950 NE 178th Pl Ste. 100, Woodinville, WA 98072, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for being clean and well-stocked, offering a wide variety of items at reasonable prices. They also appreciate the easy parking and self-checkout options available.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a03f07-2f68-7788-94c8-20a7df6293db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f07-2f68-7788-94c8-20a7df6293db",
        "storage_key": "property/5738458366607360/01a03f07-2f68-7788-94c8-20a7df6293db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/woodinville/1118",
      "poi_directions_map_url": "https://maps.google.com/?cid=11457180710870795764&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "47.7588196",
      "poi_longitude": "-122.15404699999998",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-482-6410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMz66yoIOkFQR9EXpXicVAJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_88b71879-9d47-444a-a469-46c058e06a27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "Block C of Downtown, 18025 Garden Way NE, Woodinville, WA 98072, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "Visitors say this bookstore offers a wide and well-organized selection of books, including Spanish titles, and a decent toy section with a large Lego collection. They also highlight the relaxing lighting, ample browsing space, and clean environment. Guests mention the friendly and helpful staff, who provide excellent service and recommendations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-934d-7675-aa0a-05ccf6eeccc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-934d-7675-aa0a-05ccf6eeccc0",
        "storage_key": "property/5738458366607360/01a11d8b-934d-7675-aa0a-05ccf6eeccc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2910",
      "poi_directions_map_url": "https://maps.google.com/?cid=13030691746544956896&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "47.757856399999994",
      "poi_longitude": "-122.1568571",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-398-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbVwnJCgMkFQR4DVtmhpR1rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_611f953b-dd9e-4ead-8bf3-3f53c6306db7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "17845 Garden Way NE Unit 11, Woodinville, WA 98072, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet store offers a great selection of pet products and food, including prescription options, and provides excellent grooming services. They also highlight the friendly, helpful, and attentive staff, as well as the convenient parking and quick service.\n\nSome reviews mention there can be health issues with the live fish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-9403-752b-8284-ee3cf17174fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-9403-752b-8284-ee3cf17174fe",
        "storage_key": "property/5738458366607360/01a11d8b-9403-752b-8284-ee3cf17174fe.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/wa/woodinville-store0378.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8189472978619887009&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "47.756405",
      "poi_longitude": "-122.15693549999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-424-2098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-b9e0-756e-8279-c26b24375cf8",
        "storage_key": "property/5738458366607360/019d01a2-b9e0-756e-8279-c26b24375cf8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2SrC2SkMkFQRoW1MzEjapnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_53ab6b14-a27b-4b15-bd72-9812e430048c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Dashing Nails & Spa, LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "17255 135th Ave NE Ste 1050, Woodinville, WA 98072, USA",
      "poi_short_description": "Inviting nail salon specializing in manicures and pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-934e-741c-8d45-ade948537893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-934e-741c-8d45-ade948537893",
        "storage_key": "property/5738458366607360/01a11d8b-934e-741c-8d45-ade948537893.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.dashingnailsalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=339814566891985382&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dashing-nails--spa-llc",
      "poi_latitude": "47.751907300000006",
      "poi_longitude": "-122.15929409999998",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "1",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-949-5082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-bd56-7057-bb72-c0f138d059b0",
        "storage_key": "property/5738458366607360/019d01a2-bd56-7057-bb72-c0f138d059b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XNoRPUNkFQR5pkZVYxDtwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_2db1c0be-7ff8-4f77-ae78-f99849f93fa9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "poi_name": "Bayernmoor Cellars - Woodinville",
      "poi_type": "Restaurants",
      "poi_address": "17140 135th Ave NE Ste 1040, Woodinville, WA 98072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-98c3-70c8-85ea-e09d7cc27d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a11d8b-98c3-70c8-85ea-e09d7cc27d74",
        "storage_key": "property/5738458366607360/01a11d8b-98c3-70c8-85ea-e09d7cc27d74.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.bayernmoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9178737718849266036&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bayernmoor-cellars---woodinville",
      "poi_latitude": "47.7511668",
      "poi_longitude": "-122.1589566",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "1 mins",
      "poi_business_phone": "+1 425-216-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a11d8b-a012-70d1-ba1b-6edf587c59ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a11d8b-a012-70d1-ba1b-6edf587c59ab",
        "storage_key": "property/5738458366607360/01a11d8b-a012-70d1-ba1b-6edf587c59ab.webp",
        "width": 153,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaosa6oNkFQRdGF9AlNtYX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "winery"
    }
  ],
  "office_hours": [
    {
      "id": "ec_67c7107b6444b26d6b78dac2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bfe9c295842f5825577c67fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4dafb07aac9b24e2a9ed70f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dbd0d0a7f62557c837f5ba7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_52452c6d9eb1c0a39ebaf40f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_40138664a7220ffd619a84d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_26dfd43a256e82db74d64b0d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "rating": "5",
      "name": "Katrin Mucke",
      "text": "When I moved to WCV, I didn’t know anyone here. Since I am not a dog owner, the Happy Hours during the Summer month on the A-building rooftop were my only real opportunities to meet some neighbors. That changed when our Lifestyle Director Fab entered the scene and introduced more events. From resident previews at new restaurants and wine-tasting venues to sound meditation, yoga, painting lectures, crafting workshops, walking groups, music at the plaza, community puzzle etc. we now enjoy a wide variety of offerings with something for everyone. Fab creates platforms for residents to meet, connect and build a true community, where neighbors care for each other. She supports newcomers to feel welcome and included. For me, WCV is now becoming HOME away from home, and many residents like extended family. This has made a significant difference in my life and is the main reason I have continued to renew my lease.\nFab, I thank you from the bottom of my heart!",
      "date": "2026-07-08",
      "title": "false"
    },
    {
      "id": "ec_77cea5e714941dac76da5c12",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "rating": "5",
      "name": "Yusuf Pisan",
      "text": "We love it here.\n\nIt is an 800-unit complex, so problems will happen, but in our experience management has always been responsive and any concerns we had were resolved.\n\nThis is a multi-building complex and the buildings are slightly different. Ours (Building-F Skyline) has air-conditioning while some others don’t. Our building never had issues with the garage door, but I know the garage door had to be replaced in some other buildings.\n\nWhat do we love?\n\n- Community feeling. The social director, Fab, does a great job organizing events. Wednesday is happy hour, Friday is a walking group, Tuesday is Yoga, etc. There is an activity every day of the week whether you choose to attend or not.\n\n- A very walkable neighborhood. Wilmot Gateway park and the Sammamish River Trail is less than 10 minutes away, wineries, ice cream places, and so on.\n\n- Practical Amenities: Haggen grocery store, Target, multiple coffee shops, several fast food places, several fine dining options, easy access to 405/Seattle,l\n\n- Seasonal activities (and decorations): Easter egg hunt, Halloween trick-or-treat, concerts in the plaza in the summer, decorations in the winter, social calendar in the elevator along with fun facts on people’s pets.\n\n- The complex has multiple jacuzzis on the top floors, BBQs and community gathering areas in each building that are maintained and cleaned by professionals, bike storage, indoor parking, a community room that you can pay and reserve for big events or use for free when it is available, a lounge to sit and have hot chocolate and coffee when the coffee shop gets too busy and loud.\n\n- It is a dog-friendly, no smoking anywhere complex. The WCV app is where people connect to give away or sell stuff, organize activities, look for their lost Amazon packages and so on.\n\n- The complex has several guest suites that can be rented if you have friends or family visiting.\n\n- It has a small functional gym. Private security is a plus, but Woodinville has very low crime rates anyway.\n\n- All of this is on top of Woodinville city, which is working to position itself as a wine destination, a holiday getaway. The city organizes runs, parades, concerts in the summer, car shows and a whole bunch of community events.\n\nWhat could be improved?\n\n- Sometimes people behave badly. Management tries, but people problems are hard to solve. People don’t close the trash chute when putting in their garbage so the chutes get locked. Somebody smokes weed and it makes the hallway smell. Minor problems really.\n\n- I wish the common area electricity and other expenses were included I. The rent rather than being billed separately on top of the rent. Of course these things cost money, but if it was included in the rent, there would be less complaining on the app.\n\n- I wish they had 3-bedroom units. Would love to see more families with children around. They do organize children’s activities, but most residents seem to have dogs rather than children.\n\nOverall, a great find. Highly recommended.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "ec_ddb6d2429b6e063d8022d013",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "rating": "5",
      "name": "Erik Zlndr",
      "text": "Love the location! Apartment was amazing. Top floor SE Corner of F, high ceilings, gas appliances, dog run and jacuzzi just a few steps away. Amazing neighborhood! Loooved it!",
      "date": "2026-03-30",
      "title": "false"
    },
    {
      "id": "ec_2bca050174b6e8d00db0e52e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "rating": "5",
      "name": "MaryLou",
      "text": "We have been residents at Woodin creek village for 2 years because the people hear are the best! The management here cares!\nMaintenance team is soo FAST! FAB, our\nSocial director keeps everyone BONDED! As an example this evening is our monthly resident social happy hour. We LOVE LOVE it here!!",
      "date": "2026-02-26",
      "title": "false"
    },
    {
      "id": "ec_8c652fcc2dc66c5fb56ebc7f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "rating": "4",
      "name": "Deanna Johnson",
      "text": "Fab has done a wonderful job creating a community that feels like home. She’s friendly, approachable, and truly cares about the people who live here.\n\nAnd let’s talk about the community puzzle! It started as a table with a few pieces and somehow became our neighborhood social network. Who knew a puzzle could bring so many people together?\n\nThanks, Fab, for making this more than just an apartment community. It’s the little things that make the biggest difference!",
      "date": "2026-07-09",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f3c2b734-d3b0-4d73-b88a-e97c59fef236",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a3-e233-708b-b817-5c993f72cc5b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinets",
        "public_id": "019d01a3-e233-708b-b817-5c993f72cc5b",
        "storage_key": "property/5738458366607360/019d01a3-e233-708b-b817-5c993f72cc5b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio - Freestyle",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bbWqwMYME8a"
    },
    {
      "id": "custom_a7515ab8-ef41-43be-8826-66c667950726",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/01a16a05-4dd8-7367-9040-48a975514303.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a16a05-4dd8-7367-9040-48a975514303",
        "storage_key": "property/5738458366607360/01a16a05-4dd8-7367-9040-48a975514303.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Summit",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=teHVKgrF1ZM"
    },
    {
      "id": "custom_a63dce3b-5d3a-4afe-a41d-635b237eaaf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a3-cffd-719c-8ffc-d8326fe6d0e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area with sliding glass doors and wood-look flooring.",
        "public_id": "019d01a3-cffd-719c-8ffc-d8326fe6d0e2",
        "storage_key": "property/5738458366607360/019d01a3-cffd-719c-8ffc-d8326fe6d0e2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Aspire",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1RbuQ7XAGWS"
    },
    {
      "id": "custom_e829da62-2c33-4819-a278-fdaf46c28e64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738458366607360/019d01a3-dcf1-779f-a27f-a09016e8a027.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a fireplace and balcony access",
        "public_id": "019d01a3-dcf1-779f-a27f-a09016e8a027",
        "storage_key": "property/5738458366607360/019d01a3-dcf1-779f-a27f-a09016e8a027.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Terrain",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5oE1zrMehQd"
    },
    {
      "id": "custom_5fe5b14c-7974-4961-a20d-6c07c53e5193",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Woodin Creek Village",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://repli.captur3d.io/view/woodin-creek-village/woodin-creek-village"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_8694ab00d5426bc4263c0b02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "2465712",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_f7c8bd787f5148b1afa1892e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "yardi",
      "external_id": "2465711",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 80,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-8b6d-7096-87e1-c894a3d56904",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "woodin-creek-village",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360"
    },
    {
      "lead_collector_id": "0198aa47-8bd1-70ea-ab8d-c0bce5f07e30",
      "lead_source": "FACEBOOK_ADS",
      "name": "woodin-creek-village",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360"
    },
    {
      "lead_collector_id": "0198aa47-8c33-752e-bb67-be4e4383d34d",
      "lead_source": "LANDING_PAGE",
      "name": "woodin-creek-village",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "woodin-creek-village-fitness-center-apartments",
      "search_query": "apartments with fitness center Woodinville WA",
      "category": "Amenity",
      "h1_title": "Elegant Apartments with Fitness Center in Woodinville",
      "h2_subtitle": "Discover modern apartments with a fitness center in Woodinville, WA. Enjoy a vibrant lifestyle in the heart of Woodinville's Town Center.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Woodin Creek Village, where wine country energy meets modern amenities. Our stylish apartments in Woodinville, WA, come with access to a state-of-the-art fitness center, making it easy to maintain your active lifestyle. Located in the bustling Town Center, you'll have everything you need within reach—from dining and shopping to relaxing wine-tasting rooms.\n\nChoose from our modern studio, one-, and two-bedroom homes, each designed with your lifestyle in mind. With unique features such as a barbecue area, gas range, and concierge services, you’ll enjoy a seamless living experience. Whether you're exploring local dining or unwinding in the comfort of your elegant home, Woodin Creek Village offers the ideal setting in Woodinville, WA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Woodinville, WA",
      "seo_description": "Explore Woodin Creek Village for stylish apartments with a fitness center in Woodinville, WA. Enjoy vibrant living in the heart of wine country.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "king-county-luxury-wineries-apartments",
      "search_query": "luxury apartments near wineries in King County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments Near Wineries in King County",
      "h2_subtitle": "Find exceptional luxury apartments close to renowned wineries in King County. Enjoy a sophisticated lifestyle in Woodinville's Town Center.",
      "page_copy": "Discover the pinnacle of luxury living at Woodin Creek Village, ideally situated near the renowned wineries of King County. Embrace a sophisticated lifestyle in Woodinville's vibrant Town Center, where our selection of luxury apartments offers a perfect blend of style and comfort. Each residence features modern amenities such as a barbecue area, gas range, washer/dryer, and concierge services to enhance your daily living experience.\n\nPerfectly positioned for wine enthusiasts, Woodin Creek Village provides easy access to some of the region's best wineries. Whether you are looking to indulge in a wine-tasting afternoon or enjoy upscale dining, our community places you at the heart of it all. Explore our elegant studio, one-, and two-bedroom homes and find your ideal luxury apartment near wineries in King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments by Wineries in King County",
      "seo_description": "Explore luxury apartments at Woodin Creek Village near wineries in King County. Enjoy upscale living in Woodinville's Town Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "dog-friendly-woodinville-apartments-dog-park",
      "search_query": "dog friendly apartments with dog park in Woodinville",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments with Dog Park in Woodinville",
      "h2_subtitle": "Explore dog-friendly apartments complete with a dog park in Woodinville. Perfect for you and your furry friend at Woodin Creek Village.",
      "page_copy": "At Woodin Creek Village, experience a welcoming environment for both you and your four-legged friend in scenic Woodinville. Our dog-friendly apartments not only offer cozy living spaces but also provide a dedicated dog park where your pet can run and play freely. Located in the heart of Woodinville's Town Center, enjoy all the conveniences of a vibrant community filled with shopping, dining, and local tasting rooms—all just steps away.\n\nChoose between our chic studio, one-, and two-bedroom homes, each designed with modern living in mind. With amenities such as a barbecue/grill area, gas range, and vaulted ceilings, you'll find comfort and convenience at every turn. Woodin Creek Village is more than just a home; it's a lifestyle tailored to accommodate both you and your pet's needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments with Dog Park in Woodinville",
      "seo_description": "Discover dog-friendly living at Woodin Creek Village in Woodinville, featuring a dedicated dog park and pet-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "town-center-woodinville-rooftop-lounge-apartments",
      "search_query": "rooftop lounge apartments in Town Center Woodinville",
      "category": "Amenity",
      "h1_title": "Rooftop Lounge Apartments in Town Center, Woodinville",
      "h2_subtitle": "Enjoy stunning views from rooftop lounge apartments in Town Center, Woodinville. Elevate your lifestyle at Woodin Creek Village.",
      "page_copy": "Welcome to Woodin Creek Village, where contemporary living meets breathtaking views in the heart of Town Center, Woodinville. Our apartments, featuring access to a stunning rooftop lounge, offer the perfect backdrop for entertainment and relaxation, complete with panoramic vistas of the surrounding wine country. Positioned ideally in Town Center, you'll enjoy proximity to boutique shops, gourmet dining, and local tasting rooms.\n\nOur spacious studio, one-, and two-bedroom apartments are designed with high-end features, including vaulted ceilings, gas ranges, and in-unit washer/dryers, ensuring a luxurious home experience. Whether you're hosting friends in the rooftop lounge or exploring the charming neighborhood of Woodinville, Woodin Creek Village offers a unique lifestyle defined by elegance and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Lounge Apartments in Town Center, Woodinville",
      "seo_description": "Discover rooftop lounge apartments at Woodin Creek Village in Town Center, Woodinville. Experience elevated living with stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "98072-electric-car-charging-apartments",
      "search_query": "electric car charging apartments in 98072",
      "category": "Amenity",
      "h1_title": "Electric Car Charging Apartments in 98072",
      "h2_subtitle": "Find apartments with electric car charging capabilities in 98072. Discover modern and sustainable living at Woodin Creek Village.",
      "page_copy": "Woodin Creek Village offers a blend of style and sustainability with our electric car charging amenities in Woodinville, conveniently located in the 98072 ZIP code. Embrace an eco-friendly lifestyle while enjoying the benefits of living in a modern community nestled in the vibrant Town Center. Our community is designed to meet the needs of today's eco-conscious residents seeking both convenience and comfort.\n\nExplore our thoughtfully designed studio, one-, and two-bedroom homes, equipped with premium features like gas ranges, vaulted ceilings, and in-unit washers and dryers. As part of Woodin Creek Village, you'll have quick access to electric car charging stations, allowing you to explore Woodinville and beyond with ease. Enjoy sustainable and stylish living in the heart of wine country without compromising on luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Electric Car Charging Apartments in 98072",
      "seo_description": "Explore eco-friendly living with electric car charging at Woodin Creek Village in the 98072 ZIP code. Sustainable meets stylish in Woodinville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "woodinville-wa-studio-apartments",
      "search_query": "studio apartments in Woodinville WA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Woodinville, WA",
      "h2_subtitle": "Discover the perfect studio apartments in Woodinville, WA. Experience modern living at Woodin Creek Village.",
      "page_copy": "Located in the lively Town Center of Woodinville, WA, Woodin Creek Village offers elegantly designed studio apartments that blend style with comfort. Perfectly positioned in the heart of Woodinville's bustling community, these studios provide easy access to a variety of dining options, shopping, and tasting rooms, making them ideal for anyone looking to immerse themselves in a vibrant neighborhood.\n\nOur modern studio apartments feature high-quality amenities, including gas ranges, in-unit washers and dryers, and at select units, vaulted ceilings. Live the lifestyle you’ve always wanted, surrounded by conveniences that enhance your everyday routine. Experience Woodin Creek Village today and discover why our community is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Woodinville, WA",
      "seo_description": "Find stylish studio apartments at Woodin Creek Village in Woodinville, WA. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "king-county-one-bedroom-apartments",
      "search_query": "one bedroom apartments King County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in King County",
      "h2_subtitle": "Explore charming one-bedroom apartments in King County at Woodin Creek Village. Enjoy upscale living in a vibrant community.",
      "page_copy": "At Woodin Creek Village in King County, we offer stunning one-bedroom apartments that perfectly combine modern aesthetics with the comforts of home. Located centrally in Woodinville’s Town Center, our community is surrounded by the allure of wine country, offering endless opportunities to explore local wineries, dining, and entertainment just steps away from your door.\n\nOur one-bedroom apartments come with high-end features such as gas ranges, vaulted ceilings in select units, and in-unit washers and dryers, ensuring a luxurious living experience. Residents can unwind in our communal spaces, including a barbecue area, and enjoy the convenience of a concierge service, all within a vibrant setting that promotes a life of ease and sophistication. Come and see why Woodin Creek Village is the ideal location for your next home in King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in King County",
      "seo_description": "Discover one-bedroom apartments at Woodin Creek Village in King County, featuring modern amenities and a vibrant location in Woodinville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "town-center-woodinville-two-bedroom-apartments",
      "search_query": "two bedroom apartments near Town Center Woodinville",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Town Center",
      "h2_subtitle": "Discover spacious two-bedroom apartments near Woodinville's Town Center. Enjoy the convenience and charm at Woodin Creek Village.",
      "page_copy": "Woodin Creek Village offers expansive two-bedroom apartments just a short stroll from Woodinville's vibrant Town Center. Perfectly situated, our community provides the ideal blend of suburban tranquility and urban convenience, with local dining, shopping, and tasting rooms all within easy reach.\n\nEach two-bedroom home is thoughtfully designed with your comfort in mind, featuring luxurious amenities like gas ranges, in-unit washers and dryers, and the option of vaulted ceilings in select units. Residents can take advantage of our barbecue/grill area for social gatherings or relax with our dedicated concierge services. At Woodin Creek Village, enjoy a vibrant community where wine country energy meets everyday relaxation, making it the perfect place to call home near Town Center Woodinville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Town Center",
      "seo_description": "Explore two-bedroom apartments at Woodin Creek Village, close to Town Center Woodinville. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-hollywood-hill-elementary-school",
      "search_query": "apartments near hollywood hill elementary school woodinville",
      "category": "School",
      "h1_title": "Apartments Near Hollywood Hill Elementary",
      "h2_subtitle": "Find ideal apartments near Hollywood Hill Elementary School in Woodinville. Woodin Creek Village offers proximity and convenience.",
      "page_copy": "Woodin Creek Village is perfectly located for families seeking apartments near Hollywood Hill Elementary School in Woodinville. Living in our stylish community means you'll enjoy the benefits of a prime location, just a short drive from the school, making it ideal for families with young children.\n\nOur community offers a variety of apartment options, with modern amenities including gas ranges, in-unit washers and dryers, and vaulted ceilings in select units. Families will appreciate the community's commitment to convenience and comfort, with services such as a concierge available. Nestled in the vibrant Town Center, Woodin Creek Village combines the serenity of suburban life with the amenities of city living, making it a perfect home base for families prioritizing education and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hollywood Hill Elementary",
      "seo_description": "Discover convenient living at Woodin Creek Village, just minutes from Hollywood Hill Elementary School in Woodinville. Perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-leota-middle-school-98072",
      "search_query": "apartments by leota middle school 98072",
      "category": "School",
      "h1_title": "Apartments by Leota Middle School 98072",
      "h2_subtitle": "Discover convenient apartments near Leota Middle School in the 98072 area. Woodin Creek Village offers a perfect location for families.",
      "page_copy": "Located in the vibrant Town Center of Woodinville, Woodin Creek Village provides exceptional apartment living just moments from Leota Middle School in the 98072 area. This prime location is perfect for families seeking a blend of educational convenience and luxurious living.\n\nOur community features a variety of modern apartment options complete with desirable amenities such as gas ranges, in-unit washers and dryers, and select units boasting vaulted ceilings. Families can enjoy the peace of mind provided by our concierge services, as well as socializing in our barbecue/grill area. With its proximity to quality education and the attractions of Woodinville's Town Center, Woodin Creek Village stands out as a top choice for those wanting a perfect home environment near Leota Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Leota Middle School 98072",
      "seo_description": "Live near Leota Middle School with stunning apartments at Woodin Creek Village. Ideal family-friendly location in Woodinville, 98072.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-woodinville-high-school",
      "search_query": "woodinville high school apartments nearby",
      "category": "School",
      "h1_title": "Woodinville High School Apartments Nearby",
      "h2_subtitle": "Find beautiful apartments near Woodinville High School. Woodin Creek Village offers families an ideal living experience.",
      "page_copy": "Woodin Creek Village presents an excellent residential opportunity for families looking for apartments near Woodinville High School. Situated in the heart of Woodinville's Town Center, our community offers both convenience and comfort, just a short drive from the school.\n\nAt our community, residents can choose from a selection of stylish apartments, each equipped with modern amenities such as gas ranges, in-unit washers and dryers, and the option of vaulted ceilings. Community facilities include a barbecue/grill area and professional concierge services to supplement a bustling lifestyle. Embrace the dynamic energy of wine country living combined with top-notch educational opportunities by making Woodin Creek Village your family's home near Woodinville High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodinville High School Apartments Nearby",
      "seo_description": "Discover convenient living at Woodin Creek Village, close to Woodinville High School. Enjoy modern amenities in a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-kokanee-elementary-school",
      "search_query": "apartments in proximity to kokanee elementary school woodinville wa",
      "category": "School",
      "h1_title": "Apartments Proximate to Kokanee Elementary",
      "h2_subtitle": "Explore premium apartments near Kokanee Elementary School in Woodinville, WA. Woodin Creek Village offers a perfect setting for families.",
      "page_copy": "Woodin Creek Village is an ideal community for anyone searching for apartments in proximity to Kokanee Elementary School in Woodinville, WA. Nestled in the charming Town Center, our community provides a blend of modern living and educational convenience.\n\nResidents can choose from studio, one-, and two-bedroom layouts that are equipped with amenities like gas ranges and in-unit washers and dryers, with select units featuring vaulted ceilings. Our community also offers concierge services and a barbecue/grill area, catering to both family and social needs. Living at Woodin Creek Village not only offers easy access to Kokanee Elementary School but also immerses you in the vibrant lifestyle of Woodinville, making it a perfect choice for families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Proximate to Kokanee Elementary",
      "seo_description": "Discover apartments near Kokanee Elementary School in Woodinville, WA. Experience stylish living with modern amenities at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-cottage-lake-elementary",
      "search_query": "apartments close to cottage lake elementary school king county",
      "category": "School",
      "h1_title": "Apartments Close to Cottage Lake Elementary",
      "h2_subtitle": "Find apartments conveniently located near Cottage Lake Elementary School in King County. Experience family-friendly living at Woodin Creek Village.",
      "page_copy": "Woodin Creek Village offers an exceptional living experience for families seeking apartments close to Cottage Lake Elementary School in King County. Situated in the heart of Woodinville's Town Center, our community combines convenience with upscale living.\n\nChoose from a variety of stylish studio, one-, and two-bedroom apartments, equipped with amenities such as gas ranges, in-unit washers and dryers, and select units featuring vaulted ceilings. Enjoy community perks like our barbecue/grill area and concierge services. With its prime location, Woodin Creek Village offers easy access to not only Cottage Lake Elementary School but also the dynamic lifestyle and attractions of Woodinville. Make Woodin Creek Village your family's new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cottage Lake Elementary",
      "seo_description": "Live near Cottage Lake Elementary School in King County. Woodin Creek Village offers modern apartments with amenities in a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-washington-bothell",
      "search_query": "university of washington bothell nearby apartments",
      "category": "School",
      "h1_title": "University of Washington Bothell Nearby Apartments",
      "h2_subtitle": "Discover exceptional apartments near the University of Washington Bothell. Experience convenience and style at Woodin Creek Village.",
      "page_copy": "Woodin Creek Village is an ideal choice for students and professionals seeking apartments near the University of Washington Bothell. Located in the vibrant Town Center of Woodinville, our community provides a perfect blend of academic convenience and upscale living.\n\nOur stylish studio, one-, and two-bedroom apartments are equipped with modern amenities, including gas ranges, in-unit washers and dryers, and optional vaulted ceilings. Community features like a barbecue/grill area and concierge services enhance the living experience. Woodin Creek Village not only offers proximity to the University of Washington Bothell but also allows residents to enjoy the dynamic lifestyle of Woodinville, with its rich selection of dining, shopping, and recreational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "University of Washington Bothell Nearby Apartments",
      "seo_description": "Find convenient apartments near University of Washington Bothell. Woodin Creek Village offers modern living with great amenities in Woodinville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-cascadia-college-woodinville",
      "search_query": "casadia college woodinville washington apartments",
      "category": "School",
      "h1_title": "Cascadia College Woodinville Apartments",
      "h2_subtitle": "Explore modern apartments near Cascadia College in Woodinville, Washington. Enjoy convenient, stylish living at Woodin Creek Village.",
      "page_copy": "At Woodin Creek Village, we offer a premium living experience for those seeking apartments near Cascadia College in Woodinville, Washington. Ideally positioned in the Town Center, our community provides easy access to educational opportunities while delivering the comforts of modern living.\n\nChoose from our range of studio, one-, and two-bedroom apartments that feature amenities like gas ranges, washers and dryers in every unit, and select options with vaulted ceilings. Residents can also take advantage of community amenities such as the barbecue/grill area and our handy concierge services. Living at Woodin Creek Village not only ensures proximity to Cascadia College but also places you within reach of Woodinville's vibrant dining, shopping, and cultural venues, enhancing your lifestyle and study experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cascadia College Woodinville Apartments",
      "seo_description": "Discover apartments near Cascadia College in Woodinville, WA. Woodin Creek Village offers stylish, convenient living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-evergreenhealth-medical-center",
      "search_query": "apartments near evergreenhealth medical center woodinville",
      "category": "Hospital",
      "h1_title": "Apartments Near EvergreenHealth Medical Center",
      "h2_subtitle": "Find premium apartments near EvergreenHealth Medical Center in Woodinville. Experience comfort and convenience at Woodin Creek Village.",
      "page_copy": "Woodin Creek Village is an exceptional choice for healthcare professionals and patients seeking apartments near EvergreenHealth Medical Center. Conveniently located in Woodinville's Town Center, our community offers a seamless blend of proximity and luxury living.\n\nOur selection of studio, one-, and two-bedroom apartments is equipped with impressive amenities such as gas ranges, in-unit washers and dryers, and options for vaulted ceilings. Enjoy community benefits like the barbecue/grill area along with responsive concierge services. Living at Woodin Creek Village not only provides easy access to EvergreenHealth Medical Center but also immerses you in Woodinville's vibrant array of dining, shopping, and leisure activities, creating a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near EvergreenHealth Medical Center",
      "seo_description": "Discover nearby apartments to EvergreenHealth Medical Center in Woodinville. Enjoy modern amenities and convenient living at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-wilmot-gateway-park",
      "search_query": "apartments near Wilmot Gateway Park Woodinville",
      "category": "Park",
      "h1_title": "Apartments Near Wilmot Gateway Park",
      "h2_subtitle": "Discover beautiful apartments near Wilmot Gateway Park in Woodinville. Enjoy vibrant living at Woodin Creek Village.",
      "page_copy": "Located in the heart of Woodinville's Town Center, Woodin Creek Village offers ideal living for those seeking apartments near Wilmot Gateway Park. Our community provides a perfect blend of natural beauty and modern convenience, making it an attractive choice for those who love outdoor activities and stylish living.\n\nChoose from our modern studio, one-, and two-bedroom layouts, each equipped with amenities such as gas ranges, in-unit washers and dryers, and optional vaulted ceilings. Community features like the barbecue/grill area and dedicated concierge services enhance daily living. Beyond proximity to Wilmot Gateway Park, residents of Woodin Creek Village can indulge in Woodinville’s dynamic environment filled with appealing shopping, dining, and recreational venues.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wilmot Gateway Park",
      "seo_description": "Find stunning apartments near Wilmot Gateway Park in Woodinville. Woodin Creek Village offers modern amenities and vibrant living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "woodin-creek-park-close-apartments",
      "search_query": "Woodinville apartments close to Woodin Creek Park",
      "category": "Park",
      "h1_title": "Woodinville Apartments Close to Woodin Creek Park",
      "h2_subtitle": "Experience stylish living in Woodinville apartments close to Woodin Creek Park. Discover Woodin Creek Village today.",
      "page_copy": "Nestled in Woodinville’s bustling Town Center, Woodin Creek Village offers prime living options for those seeking Woodinville apartments close to Woodin Creek Park. Residents enjoy an ideal location that combines natural beauty with urban convenience.\n\nOur community features an array of studio, one-, and two-bedroom apartments, each furnished with top-notch amenities like gas ranges and in-unit washers and dryers. Select apartments even boast vaulted ceilings for added elegance. Enjoy community perks such as a barbecue/grill area and attentive concierge services. Living here not only places you steps away from Woodin Creek Park but also within reach of Woodinville's exciting dining, shopping, and cultural scenes, ensuring a well-rounded lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodinville Apartments Close to Woodin Creek Park",
      "seo_description": "Discover Woodinville apartments near Woodin Creek Park. Enjoy modern living and amenities at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "deyoung-park-nearby-apartments",
      "search_query": "DeYoung Park nearby apartments Woodinville WA",
      "category": "Park",
      "h1_title": "DeYoung Park Nearby Apartments in Woodinville",
      "h2_subtitle": "Explore Woodinville living with DeYoung Park nearby. Discover Woodin Creek Village apartments today.",
      "page_copy": "Woodin Creek Village is the perfect choice for those looking for DeYoung Park nearby apartments in Woodinville, WA. Our community is strategically located in the Town Center, offering easy access to one of Woodinville's most charming parks.\n\nThe apartment community provides its residents with a selection of stylish studio, one-, and two-bedroom layouts, each fitted with modern amenities like gas ranges and in-unit washers and dryers. Vaulted ceilings are an option in select apartments, providing a spacious feel. Residents can utilize community features such as barbecue/grill areas and concierge services. Whether it's a leisurely stroll through DeYoung Park or experiencing Woodinville’s vibrant shopping and dining scene, enjoy suburban comfort with urban convenience at Woodin Creek Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "DeYoung Park Nearby Apartments Woodinville",
      "seo_description": "Find apartments near DeYoung Park in Woodinville, WA. Enjoy the perfect blend of nature and modern amenities at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-rotary-community-park",
      "search_query": "apartments near Rotary Community Park Woodinville",
      "category": "Park",
      "h1_title": "Apartments Near Rotary Community Park",
      "h2_subtitle": "Discover premium apartments near Rotary Community Park in Woodinville. Experience the charm of Woodin Creek Village today.",
      "page_copy": "For those seeking apartments near Rotary Community Park in Woodinville, Woodin Creek Village offers an unparalleled living experience. Situated in the vibrant Town Center, our community is well-positioned to provide both accessibility to natural spaces and urban amenities.\n\nWoodin Creek Village presents a range of contemporary studio, one-, and two-bedroom apartments that come equipped with modern features such as gas ranges, washers and dryers, and options for vaulted ceilings. Residents can also enjoy our community amenities, including a designated barbecue/grill area and dedicated concierge services, ensuring convenience and comfort. Living here not only places you a short distance from Rotary Community Park but also within a thriving neighborhood filled with lively dining and shopping options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rotary Community Park",
      "seo_description": "Discover apartments near Rotary Community Park in Woodinville. Enjoy modern amenities and a great location at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "cottage-lake-park-apartments-woodin-county",
      "search_query": "Cottage Lake Park apartments Woodin County",
      "category": "Park",
      "h1_title": "Cottage Lake Park Apartments in Woodin County",
      "h2_subtitle": "Explore Cottage Lake Park apartments in Woodin County for a blend of nature and modern living. Discover Woodin Creek Village today.",
      "page_copy": "For those seeking Cottage Lake Park apartments in Woodin County, Woodin Creek Village is an ideal choice. Located in the heart of Woodinville’s Town Center, our community combines modern living with easy access to natural attractions like Cottage Lake Park.\n\nWoodin Creek Village offers a variety of studio, one-, and two-bedroom apartments, equipped with amenities such as gas ranges and in-unit washers and dryers. Select units come with spacious vaulted ceilings. Community essentials like a barbecue/grill area and reliable concierge services enhance your living experience. With our apartments, you'll enjoy the tranquility of Cottage Lake Park while engaging with the vibrant culture and amenities of Woodinville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottage Lake Park Apartments in Woodin County",
      "seo_description": "Discover Cottage Lake Park apartments in Woodin County. Experience natural beauty and upscale amenities at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "greenbrier-park-king-county-apartments",
      "search_query": "Greenbrier Park King County apartments",
      "category": "Park",
      "h1_title": "Greenbrier Park King County Apartments",
      "h2_subtitle": "Find stunning apartments near Greenbrier Park in King County. Explore Woodin Creek Village for a perfect blend of nature and comfort.",
      "page_copy": "For those looking for Greenbrier Park King County apartments, Woodin Creek Village provides an excellent opportunity to enjoy stylish living in close proximity to this beautiful park. Our community, nestled in Woodinville’s lively Town Center, enables easy access to nature and urban attractions.\n\nOffering chic studio, one-, and two-bedroom apartments, Woodin Creek Village features amenities like gas ranges, in-unit washers and dryers, and options for lofty vaulted ceilings. Residents appreciate community perks like a barbecue/grill area and concierge services for an elevated living experience. Living here means enjoying the scenic beauty of Greenbrier Park while being part of a dynamic and convenient neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Greenbrier Park, King County",
      "seo_description": "Explore apartments near Greenbrier Park in King County. Experience stylish living with great amenities at Woodin Creek Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "woodinville-heights-park-living-spaces",
      "search_query": "Woodinville Heights Park living spaces 98072",
      "category": "Park",
      "h1_title": "Woodinville Heights Park Living Spaces",
      "h2_subtitle": "Explore modern living spaces near Woodinville Heights Park. Discover life at Woodin Creek Village designed for the 98072 area.",
      "page_copy": "For those interested in Woodinville Heights Park living spaces within the 98072 area, Woodin Creek Village offers a sophisticated lifestyle in a prime location. Situated in Woodinville’s bustling Town Center, our community is perfectly positioned for residents to enjoy nearby parks and urban conveniences.\n\nWoodin Creek Village features contemporary studio, one-, and two-bedroom apartments equipped with top-tier amenities including gas ranges and in-unit washers and dryers. Select units also boast desirable vaulted ceilings. With a well-equipped barbecue/grill area and comprehensive concierge services, residents at Woodin Creek enjoy a blend of comfort and community. Experience the tranquility of Woodinville Heights Park while accessing the vibrant local dining, shopping, and entertainment options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Spaces Near Woodinville Heights Park",
      "seo_description": "Discover modern living spaces near Woodinville Heights Park. Enjoy the perfect blend of comfort at Woodin Creek Village in the 98072 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "tolt-pipeline-apartments-woodin-creek-village",
      "search_query": "Tolt pipeline apartments Woodin Creek Village",
      "category": "Park",
      "h1_title": "Tolt Pipeline Apartments at Woodin Creek",
      "h2_subtitle": "Discover Tolt Pipeline apartments at Woodin Creek Village. Experience vibrant living near the scenic beauty of Tolt Pipeline Trail.",
      "page_copy": "Woodin Creek Village offers Tolt Pipeline apartments that bring you close to the picturesque Tolt Pipeline Trail while residing in Woodinville's Town Center. Perfectly designed for those who love nature and urban conveniences, our community provides an ideal balance.\n\nOffering chic studio, one-, and two-bedroom layouts, these apartments come with premium features such as gas ranges, in-unit washers and dryers, and select units with dramatic vaulted ceilings. Amenities such as a barbecue/grill area and attentive concierge services ensure a comfortable lifestyle. Embrace the energetic vibe of Woodinville while enjoying easy access to the natural allure of Tolt Pipeline Trail at Woodin Creek Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tolt Pipeline Apartments at Woodin Creek",
      "seo_description": "Explore Tolt Pipeline apartments at Woodin Creek Village. Enjoy vibrant living next to Tolt Pipeline Trail and local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5738458366607360",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-tacoma-airport-woodinville",
      "search_query": "apartments near seattle tacoma international airport woodinville",
      "category": "Transit",
      "h1_title": "Apartments Near Seattle Tacoma Airport",
      "h2_subtitle": "Find apartments near Seattle Tacoma International Airport in Woodinville. Discover Woodin Creek Village for convenience and comfort.",
      "page_copy": "For those seeking apartments near Seattle Tacoma International Airport, Woodin Creek Village in Woodinville offers an ideal living solution with easy access to both the airport and local attractions. Nestled in the vibrant Town Center, our community provides the perfect combination of urban living and convenient travel options.\n\nWoodin Creek Village features stylish studio, one-, and two-bedroom apartments equipped with modern amenities such as gas ranges, in-unit washers and dryers, and select options with vaulted ceilings. Residents enjoy a host of amenities, including a barbecue/grill area and dedicated concierge services, making it an attractive choice for frequent travelers who value comfort and efficiency. Experience the ease of living at Woodin Creek Village while enjoying the proximity to Seattle Tacoma International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
      "featured_image_media": {
        "alt_text": "Bar area with seating and wine bottles on shelves",
        "public_id": "01a03754-fac3-7242-810d-a4e9f4d8dfa3",
        "storage_key": "property/5738458366607360/01a03754-fac3-7242-810d-a4e9f4d8dfa3.webp",
        "width": 3072,
        "height": 1730
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodinville Apartments Near Seattle Tacoma Airport",
      "seo_description": "Discover Woodin Creek Village in Woodinville for convenient apartments near Seattle Tacoma International Airport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "1209"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "381963854"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564100"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PN5DM897"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "4300d2ec-574c-47e5-936a-43cd50930d2d"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Weidner Classic"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/801f95bf-5725-4360-b371-89096f200b2e/app.js?property=801f95bf-5725-4360-b371-89096f200b2e&amp;propertyName=Woodin Creek Village&amp;channelUuid=c248ee0b-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "3256169680"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/27vqgq8zwox"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5HbVYwQTA3RjJ0S1RtQnZxdjRCRFE9PSIsInZhbHVlIjoiMWpEcmJ3ckxoNXhxaEt3WnJYclJGUT09IiwibWFjIjoiMjkxODkwNTM1YjI5YzZhMmUwYmJiMTIwZTVkNTkwMTI1NDBlMGQ0NDIxOTczY2NmMzBmNTg0ZjY0MzBjMTAyNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "1209",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "381963854",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564100",
  "custom_google_gtm_id": "GTM-PN5DM897",
  "custom_rollout_phase": "Phase 7",
  "custom_rentgrata_token": "4300d2ec-574c-47e5-936a-43cd50930d2d",
  "custom_vibesites_theme": "Weidner Classic",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/801f95bf-5725-4360-b371-89096f200b2e/app.js?property=801f95bf-5725-4360-b371-89096f200b2e&amp;propertyName=Woodin Creek Village&amp;channelUuid=c248ee0b-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "3256169680",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/27vqgq8zwox",
  "custom_website_subscription": "custom",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5HbVYwQTA3RjJ0S1RtQnZxdjRCRFE9PSIsInZhbHVlIjoiMWpEcmJ3ckxoNXhxaEt3WnJYclJGUT09IiwibWFjIjoiMjkxODkwNTM1YjI5YzZhMmUwYmJiMTIwZTVkNTkwMTI1NDBlMGQ0NDIxOTczY2NmMzBmNTg0ZjY0MzBjMTAyNCJ9"
};

export const generatedAt = '2026-11-03T21:25:40.053Z';
